import { TabBookingAbstract } from '@/components/Cargo/Job/booking/tabs/tabBookingAbstract.js'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { canCreateByCreditInfoDetail } from '@/api/partner/creditInfo'
import { dateCompare, dateCompareYMD, mergeArray, multiply } from '@/utils/commonUtil'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { User } from '@/class/model/sys/User'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as OverseaAgentGrade from '@/class/cargo/model/parameters/OverseaAgentGrade'
import { Office } from '@/class/model/sys/Office'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { ClosingAccount } from '@/class/model/act/ClosingAccount'
import { getCacheListByKey, getSpecificBasicData, getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { SopEmailReceiver } from '@/class/model/booking/SopEmailReceiver'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { SopPushConfig } from '@/class/model/sys/SopPushConfig'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import StrUtils from '@/utils/StrUtils'
import { changeOperateType, getTemperatureRequirement } from '@/api/AirExport/airExportJob'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { AirCargoDocUtil } from '@/class/cargo/model/utils/AirCargoDocUtil'
import { AirPort } from '@/class/model/mdm/AirPort'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { IataPrice } from '@/class/model/sys/IataPrice'
import { queryMAWBInfo } from '@/api/partner/mawbInfo'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import $store from '@/store'
import { findBusinessDocument } from '@/api/seaExport/businessDocument'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading } from '@/utils/utilBaseElement'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import lodash from 'lodash'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { OverseaAgent } from '@/class/model/sys/OverseaAgent'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { OperationRequirementDescription } from '@/class/model/mdm/OperationRequirementDescription'
import { sortByMultiField } from '@/utils'
import { warehouseInList } from '@/api/seaExport/warehouseIn'
import DateUtils from '@/utils/dateUtils'
import {
  CHARGE_SOURCE_SPLIT,
  IMPERIAL_1,
  LOG_AE_AIR_BOOKING
} from '@/class/cargo/model/parameters/SystemConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import moment from 'moment'
import { queryAirlineProductDownList } from '@/api/booking/airlineProduct'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'

export class TabGeneralHP extends TabBookingAbstract {
  constructor(view) {
    super(view)
    this.view = view
    this.$confirm = view.$confirm
    this.$t = this.view.$t
  }

  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }
  // 初始化
  init() {
    this.trustFromEditSales = Number(this.config.get('TrustFromEditSales')) === 1
    this.isSpecifiedSalesBusiness = Number(this.config.get('IsSpecifiedSalesBusiness')) === 1
    this.branchOfficeCheck = Number(this.config.get('departmentSalesOfficeCheck')) === 1
    this.cWeightIsCeil = Number(this.config.get('AEcWeightCeil')) // 计费重量是否取整
    this.refSelDesignationAgent = Number(this.config.get('refSelDesignationAgent')) === 1
    this.airCargoEnglishName = Number(this.config.get('airCargoEnglishName'))
    this.airCargoMark = Number(this.config.get('airCargoMark'))
    this.syncCustomerShippingInfoBothBolAndBasicTab = Number(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1 || (Number(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 2 && this.view.action === 'add')
    // 初始化 航线产品下拉列表
    queryAirlineProductDownList({ containVoyage: false, branchId: $store.getters.currentOfficeId }).then(res => {
      this.view.airlineProductDownList = res.data
    })
    JobUtils.initImperialSetting().then(r => {
      this.view.showImperialButton = r
    })
    JobUtils.initImperialData(IMPERIAL_1.code).then(r => {
      this.view.isOpenImperial = r
      this.view.originalImperial = r
    })
    getTemperatureRequirement().then(res => {
      this.view.temperatureRequirementDownList = res.data
    })
    console.log('temperatureRequirementDownList', this.view.temperatureRequirementDownList)
  }
  // 更新页面显示(此方法中包含了原来的fillView方法以及changeJob方法)
  async fillView() { //
    const job = this.job
    if (!job) return
    await this.checkJobHBL() // 此处一定要await，不然提单数据不对
    await this.loadIsWithinClosingAccountDate() // 信控
    this.loadCustomerContacts() // 加载客户的联系人和特殊需求等信息
    this.loadCustomerLevel()
    await this.loadOverseaAgentChanged()
    if (!job.uuid) {
      await this.getOverseaAgentUserByConfig()
      // 校验新增业务的信控
      await this.checkNewJobCreditInfo()
    }
    if (!job.uuid) { // 业务新增
      if (job.sales > 0) {
        this.checkSalesOfficeAndDepartment(job)
      }
      this.selectJobType()
      this.changeMAWBInfo(job.carrierId)
      JobUtils.matchUserPortConfig(this.view, job)
      JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData, true)
    } else {
      JobUtils.matchUserPortConfig(this.view, job, false, null, { keepOriginValue: true })
    }
    // 校验是否有分摊费用
    job.hasSharedCharge = false
    job.hasSharedCharge = await new AirExportJob(job).checkShareCharge()
    // 信控超期提醒
    this.sopConfig()
    if (!this.isSpecifiedSalesBusiness) {
      if (this.view.salesOfficeCheck) {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, $store.getters.currentOfficeId, true)
      } else {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, null, true)
      }
    } else {
      this.loadUser()
    }
    this.checkMAWBRelationState()
    this.updateLoading3Code()
    this.updateDestination3Code()
    this.loadCompanyOffice()
    this.checkVesselLine()
    this.view.addrPM.isPortFilter = false
    this.view.addrPM.shipperCodeField = ''
    this.view.addrPM.shipperField = 'txtshipperLine'
    this.view.addrPM.consigneeCodeField = ''
    this.view.addrPM.consigneeField = 'txtconsigneeLine'
    this.view.addrPM.notifyCodeField = ''
    this.view.addrPM.notifyField = 'txtnotifyLine'
    this.loadWarehouseRegion(false)
    // CARGO-30861 ID：4976 恩跃 空运-远程订舱分单运输条款选择：FREIGHT COLLECT ，HAWB页签还出现PP显示错误以及币种
    if (!this.view.viewStatus) {
      if (this.view.mawbDoc && !this.view.mawbDoc.uuid && this.job.paymentTermMBL) {
        this.changeFreightTerm(this.view.mawbDoc, this.job.paymentTermMBL)
      }
      if (this.view.hawbDoc && !this.view.hawbDoc.uuid && this.job.paymentTermHBL) {
        this.changeFreightTerm(this.view.hawbDoc, this.job.paymentTermHBL)
      }
    }
    this.getWarehouseDate()
    // 处理复制的情况
    if (!this.job.uuid && this.view.isCopy) {
      this.syncDocHandlingInfo()
    }
  }
  // 加载销售分公司
  async loadCompanyOffice() {
    const office = await Office.getOfficeById(this.job.salesOffice)
    if (office) {
      this.view.txtSalesOffice = office.chineseName
    } else {
      this.view.txtSalesOffice = ''
    }
  }
  // 加载 客户属性
  async loadCustomerLevel() {
    const company = await Company.getCompanyById(this.job.customerId)
    this.view.advancePaymentLabel = company && company.ifAdvancePayment ? this.view.$t('Partners.IfAdvancePayment') : ''
    if (company && company.uuid) {
      const customer = await Company.loadCustomer(company.uuid).then(data => data.length > 0 ? data[0] : null)
      if (customer) {
        const customerType = await new Customer(customer).getCustomerType()
        if (customerType) {
          this.view.customerLevel.level = customerType.typeId

          this.view.customerLevel.customerName = this.view.isZh ? customerType.chineseName : customerType.englishName
        }
      }
    }
    this.getContractStatus(company)
  }
  /**
   * 加载海外客服
   */
  async loadOverseaAgentChanged() {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    let cmpIdx = 0
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      cmpIdx = job.designationAgent // 根据指定货确定海外客服
    } else {
      cmpIdx = job.destinationAgent // 还是根据目的港代理确定海外客服
    }
    const cmp = await Company.getCompanyById(cmpIdx)
    if (cmp) {
      const agent = await new Company(cmp).getOverseaAgentDetail()
      if (agent) {
        const overseaAgentUsers = await new OverseaAgent(agent).getOverseaAgentUserList()
        // 海外客服
        const overseaAgentUsersList = []
        if (overseaAgentUsers && overseaAgentUsers.length > 0) {
          for (const u of overseaAgentUsers) {
            if (u.lob === this.job.lob || !u.lob || u.lob === 'ALL') {
              const user = await User.getUserById(u.userId)
              if (user && user.active) {
                if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
                  overseaAgentUsersList.push(user)
                }
              }
            }
          }
        }
        // 海外客服
        this.view.overseaAgentUsersList = overseaAgentUsersList
        if (!this.view.overseaAgentUsersList || this.view.overseaAgentUsersList.length === 0) {
          await this.getOverseaAgentUserByConfig()
        }
      } else {
        await this.getOverseaAgentUserByConfig()
      }
    } else {
      this.view.overseaAgentUsersList = []
      await this.getOverseaAgentUserByConfig()
    }
  }
  async getOverseaAgentUserByConfig() {
    if (this.view.isHC) {
      return
    }
    const overseaAgentUsersConfig = parseInt(this.config.get('overseaAgentUsersConfig'))
    if (overseaAgentUsersConfig === 1) {
      if (this.view.$refs.overseaOp && typeof this.view.$refs.overseaOp.getUsersByPrivilegeDetail === 'function') {
        this.view.overseaAgentUsersList = await this.view.$refs.overseaOp.getUsersByPrivilegeDetail(
          `role-overseaOp--${null}-${true}`,
          'role',
          'overseaOp',
          '',
          null,
          true
        )
      }
    }
  }
  checkCredit() {
    this.view.showWarningImageA = false
    this.view.showWarningImageB = false
    this.view.showWarningImageC = false
    if (this.view.creditOpen) {
      const job = this.job
      // 委托单位
      if (job && job.customerId > 0) {
        this.checkCreditByCompany(job.customerId, 1)
      }
      // 指定货代理
      if (job && job.designationAgent > 0) {
        this.checkCreditByCompany(job.designationAgent, 2)
      }
      // 目的港代理
      if (job && job.destinationAgent > 0) {
        this.checkCreditByCompany(job.destinationAgent, 3)
      }
    }
  }
  // 检查合作伙伴是否信控超期
  // async checkCreditByCompany(companyId, type) {
  //   const callback = async credit => {
  //     let checkCredit = false
  //     if (credit) {
  //       let tip = ''
  //       if (credit.amountExceeded || credit.dateExceeded) {
  //         const config = this.getCreditEDISetting()
  //         if (config.booking) {
  //           if (credit.amountExceeded) {
  //             tip += this.view.$t('CargoMsg.Cargo_Limit')
  //           }
  //           if (credit.dateExceeded) {
  //             tip += this.view.$t('CargoMsg.Cargo_AccountPeriod')
  //           }
  //           if (tip) {
  //             const toolTip = this.view.$t('CargoMsg.Cargo_Parter') + tip + this.view.$t('SeaExport.HasExceeded')
  //             if (type === 1) {
  //               this.view.showWarningImageB = true
  //               this.view.warningImageBTip = toolTip
  //             } else if (type === 2) {
  //               this.view.showWarningImageA = true
  //               this.view.warningImageATip = toolTip
  //             } else if (type === 3) {
  //               this.view.showWarningImageC = true
  //               this.view.warningImageCTip = toolTip
  //             }
  //             checkCredit = true
  //           }
  //         }
  //       }
  //     }
  //     if (!credit || !checkCredit) {
  //       const company = await Company.getCompanyById(companyId)
  //       if (company && company.ifOpenSop && this.view.sopConfigOpen) {
  //         if (type === 1) {
  //           this.view.showWarningImageB = false
  //           this.view.sopImageB = true
  //         } else if (type === 2) {
  //           this.view.showWarningImageA = false
  //           this.view.sopImageA = true
  //         } else if (type === 3) {
  //           this.view.showWarningImageC = false
  //           this.view.sopImageC = true
  //         }
  //       }
  //     }
  //   }
  //   CreditInfo.checkCreditInfo(companyId).then(async res => {
  //     for (const item of res.data) {
  //       await callback(item)
  //     }
  //   })
  // }

  /**
   * CARGO-33143 已超期的合作伙伴没有图标标识
   * type代表不同的角色
   */
  checkCreditByCompany(companyId, type) {
    const callback = credit => {
      let checkCredit = false
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', companyId)
      if (credit) {
        let tip = ''
        if (credit.amountExceeded || credit.dateExceeded) {
          if (credit.amountExceeded) { tip += this.view.$t('CargoMsg.Cargo_Limit') }
          if (credit.dateExceeded) { tip += this.view.$t('CargoMsg.Cargo_AccountPeriod') }
          if (tip) {
            const toolTip = this.view.$t('CargoMsg.Cargo_Parter') + tip + this.view.$t('SeaExport.HasExceeded')
            if (type === 1) {
              this.view.showWarningImageB = true
              if (company && company.ifOpenSop && this.view.sopConfigOpen) {
                this.view.sopImageB = true
              }
              this.view.warningImageBTip = toolTip
            } else if (type === 2) {
              this.view.showWarningImageA = true
              this.view.warningImageATip = toolTip
            } else if (type === 3) {
              this.view.showWarningImageC = true
              this.view.warningImageCTip = toolTip
            }
            checkCredit = true
          }
        }
      }
      if (!credit || !checkCredit) {
        if (company && company.ifOpenSop && this.view.sopConfigOpen) {
          if (type === 1) {
            this.view.showWarningImageB = false
            this.view.sopImageB = true
          } else if (type === 2) {
            this.view.showWarningImageA = false
            this.view.sopImageA = true
          } else if (type === 3) {
            this.view.showWarningImageC = false
            this.view.sopImageC = true
          }
        }
      }
    }
    CreditInfo.checkCreditInfo(companyId, CreditInfoUtil.getJobData(this.job)).then(res => {
      for (const item of res.data) {
        callback(item)
      }
    })
  }
  getCreditEDISetting() {
    const setting = this.config.get('creditBlockEDI')
    const a = setting.split(',')
    const r = {}
    for (const o of a) {
      let lock = false
      if (o.split('-')[1] === '1') {
        lock = true
      }
      r[o.split('-')[0]] = lock
    }
    return r
  }
  // 加载客户详情
  async loadCustomerDetail(isNew = false) {
    const job = this.job
    const customer = await Company.getCompanyById(job.customerId)
    if (!customer) return
    const customerDetail = await new Company(customer).getCustomerDetail()
    if (customerDetail) {
      const oldCargoSource = job.cargoSource
      const newCargoSource = customerDetail.designated ? CargoSource.NC_CARGO_SOURCE.code : CargoSource.SC_CARGO_SOURCE.code

      // CARGO-15204 输入委托单位后，揽货类型会从指定货变更为自揽货的错误
      if (oldCargoSource !== newCargoSource && newCargoSource) {
        const msg = newCargoSource === CargoSource.SC_CARGO_SOURCE.code ? this.view.$t('CargoMsg.Cargo_CustomerSpace3') : this.view.$t('CargoMsg.Cargo_CustomerSpace2')
        await this.view.$confirm(this.view.$t('CargoMsg.Cargo_CargoSourceTip', [msg]), this.view.$t('common.tips.prompt'), {
          confirmButtonText: this.view.$t('common.btn.yes'),
          cancelButtonText: this.view.$t('common.btn.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          job.cargoSource = newCargoSource
          this.checkNewJobCreditInfo()
        }).catch(() => {
        })
      }
      if (this.isSpecifiedSalesBusiness) {
        if (job.designationAgent > 0) {
          await this.loadOverseaAgentDetailOwner(job.designationAgent)
        }
        await this.loadCompanyUser()
      } else if (!this.isSpecifiedSalesBusiness) {
        const salesTemp = customerDetail.sales
        const user = await User.getUserById(salesTemp)
        if (user && user.active) {
          if (this.view.salesOfficeCheck) {
            const userList = this.view.salesList
            job.sales = 0
            for (const item in userList) {
              if (user.userId === item.userId) {
                job.sales = salesTemp
              }
            }
          } else {
            job.sales = salesTemp
          }
          await this.salesChangeHandler({ ...user, value: user.userId })
        }
      }
    }
  }
  // 获取合约状态
  getContractStatus(company) {
    this.view.stampPictureView.businessDocuments = []
    if (!company) return
    Company.loadAgreementClientContract(company.uuid).then(async contracts => {
      if (contracts && contracts.length > 0) {
        const now = moment()
        const businessIds = []
        for (const item of contracts) {
          // 过滤出当前合作伙伴所有未到期的合同
          if (dateCompareYMD(item.endDate, now) >= 0) {
            businessIds.push(item.uuid)
          }
        }
        if (businessIds.length > 0) {
          findBusinessDocument({ businessIds: businessIds }).then(res => {
            const docs = res.data
            if (docs && docs.length > 0) {
              const useDocs = []
              for (const doc of docs) {
                if (!doc.fileCategory || doc.fileCategory !== 'STAMP') continue
                if (!doc.fileType || !SystemConstants.IMAGES.includes(doc.fileType.toUpperCase())) continue
                useDocs.push(doc)
              }
              this.view.stampPictureView.businessDocuments = useDocs
            }
          })
        }
        company.contractStatus = businessIds.length > 0 ? 2 : 1
      } else {
        company.contractStatus = 0
      }
      const contractState = this.view.contractStatuses[company.contractStatus]
      this.view.contractStatus = company.contractStatus
      this.view.contractStatusLabel = contractState ? contractState.label : ''
      this.view.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.job))
    })
  }
  // 按业务指定对应的服务人员
  async loadCompanyUser() {
    if (this.isSpecifiedSalesBusiness) {
      const company = await Company.getCompanyById(this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadCompanyUserHandler(data)
        })
      } else {
        this.job.sales = 0
        this.view.salesList = null
        if (this.view.salesOfficeCheck) {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, $store.getters.currentOfficeId, true)
        } else {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, null, true)
        }
        this.getTxtSalesPrompt()
      }
    }
  }
  async loadCompanyUserHandler(companyUsers) {
    const job = this.job
    // 销售
    const salesList = []
    let salesDefaultId = 0
    // 客服
    const csrList = []
    let csrDefaultId = 0
    // 单证
    const dcList = []
    let dcDefaultId = 0
    // 揽货销售
    const cargoSalesList = []
    let cargoSalesId = 0
    // 操作
    const opList = []
    let opDefaultId = 0
    // 海外客服
    const overseaOpList = []
    let overseaOpDefaultId = 0
    // 自定义岗位1
    const userDefinedRoleId1List = []
    let userDefinedRoleId1 = 0
    // 自定义岗位2
    const userDefinedRoleId2List = []
    let userDefinedRoleId2 = 0
    // 自定义岗位3
    const userDefinedRoleId3List = []
    let userDefinedRoleId3 = 0
    // 自定义岗位4
    const userDefinedRoleId4List = []
    let userDefinedRoleId4 = 0
    // 自定义岗位5
    const userDefinedRoleId5List = []
    let userDefinedRoleId5 = 0
    // 自定义岗位6
    const userDefinedRoleId6List = []
    let userDefinedRoleId6 = 0
    // 自定义岗位7
    const userDefinedRoleId7List = []
    let userDefinedRoleId7 = 0
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList = []
    if (this.view.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId)
    }
    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        const userValid = job.fba ? u.lob === SystemConstants.FBA_AE.code : u.lob === job.lob
        if (!u.lob || userValid || u.lob === 'ALL') {
          const user = await User.getUserById(u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
              if (this.view.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    if (u.defaultUser) {
                      salesDefaultId = u.userId
                    }
                    salesList.push(user)
                  }
                }
              } else {
                if (u.defaultUser) {
                  salesDefaultId = u.userId
                }
                salesList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
              if (u.defaultUser) {
                csrDefaultId = u.userId
              }
              csrList.push(user)
            } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
              if (u.defaultUser) {
                dcDefaultId = u.userId
              }
              dcList.push(user)
            } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
              if (u.defaultUser) {
                cargoSalesId = u.userId
              }
              cargoSalesList.push(user)
            } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
              if (u.defaultUser) {
                opDefaultId = u.userId
              }
              opList.push(user)
            } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaOpDefaultId = u.userId
              }
              overseaOpList.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE1.code) { // 自定义岗位1
              if (u.defaultUser) {
                userDefinedRoleId1 = u.userId
              }
              userDefinedRoleId1List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE2.code) { // 自定义岗位2
              if (u.defaultUser) {
                userDefinedRoleId2 = u.userId
              }
              userDefinedRoleId2List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE3.code) { // 自定义岗位3
              if (u.defaultUser) {
                userDefinedRoleId3 = u.userId
              }
              userDefinedRoleId3List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE4.code) { // 自定义岗位4
              if (u.defaultUser) {
                userDefinedRoleId4 = u.userId
              }
              userDefinedRoleId4List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE5.code) { // 自定义岗位5
              if (u.defaultUser) {
                userDefinedRoleId5 = u.userId
              }
              userDefinedRoleId5List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE6.code) { // 自定义岗位6
              if (u.defaultUser) {
                userDefinedRoleId6 = u.userId
              }
              userDefinedRoleId6List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE7.code) { // 自定义岗位7
              if (u.defaultUser) {
                userDefinedRoleId7 = u.userId
              }
              userDefinedRoleId7List.push(user)
            }
          }
        }
      }
    }
    if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
      // 销售
      this.view.salesList = salesList
      if (salesList.length > 0) {
        if (salesDefaultId > 0) {
          job.sales = salesDefaultId
        } else {
          job.sales = salesList[0].userId
        }
        const user = await User.getUserById(job.sales)
        this.view.$nextTick(() => {
          this.salesChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.sales = 0
        // job.salesDepartment = 0
        // this.view.txtSalesOffice = ''
      }
    }
    // 客服
    if (csrList.length > 0) {
      if (csrDefaultId > 0) {
        job.csr = csrDefaultId
      } else {
        job.csr = csrList[0].userId
      }

      const user = await User.getUserById(job.csr)
      this.view.$nextTick(() => {
        this.csrChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.csr = 0
      // job.csrDepartment = 0
    }
    // 单证
    if (dcList.length > 0) {
      if (dcDefaultId > 0) {
        job.dc = dcDefaultId
      } else {
        job.dc = dcList[0].userId
      }
      const user = await User.getUserById(job.dc)
      this.view.$nextTick(() => {
        this.dcChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.dc = 0
      // job.dcDepartment = 0
    }
    // 揽货销售
    if (cargoSalesList.length > 0) {
      if (cargoSalesId > 0) {
        job.cargoSalesId = cargoSalesId
      } else {
        job.cargoSalesId = cargoSalesList[0].userId
      }

      const user = await User.getUserById(job.cargoSalesId)
      this.view.$nextTick(() => {
        this.cargoSalesChargeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.cargoSalesId = 0
      // job.cargoSalesOffice = 0
      // job.cargoSalesDepartment = 0
    }
    if (this.view.isHC) {
      // 操作
      if (opList.length > 0) {
        if (opDefaultId > 0) {
          job.op = opDefaultId
        } else {
          job.op = opList[0].userId
        }

        const user = await User.getUserById(job.op)
        this.view.$nextTick(() => {
          this.opChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.op = 0
        // job.opDepartment = 0
      }
      // 海外客服
      if (overseaOpList.length > 0) {
        if (overseaOpDefaultId > 0) {
          job.overseaOp = overseaOpDefaultId
        } else {
          job.overseaOp = overseaOpList[0].userId
        }

        const user = await User.getUserById(job.overseaOp)
        this.view.$nextTick(() => {
          this.overseaOpChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.overseaOp = 0
        // job.overseaOpDepartment = 0
      }
    }
    // 自定义岗位1
    if (userDefinedRoleId1List.length > 0) {
      job.userDefinedRoleId1 = userDefinedRoleId1 > 0 ? userDefinedRoleId1 : userDefinedRoleId1List[0].userId
      const user = await User.getUserById(job.userDefinedRoleId1)
      this.view.$nextTick(() => {
        this.userDefinedRoleId1Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId1 = 0
      // job.userDefinedRoleDept1 = 0
      // job.userDefinedRoleOffice1 = 0
    }
    // 自定义岗位2
    if (userDefinedRoleId2List.length > 0) {
      job.userDefinedRoleId2 = userDefinedRoleId2 > 0 ? userDefinedRoleId2 : userDefinedRoleId2List[0].userId
      const user = await User.getUserById(job.userDefinedRoleId2)
      this.view.$nextTick(() => {
        this.userDefinedRoleId2Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId2 = 0
      // job.userDefinedRoleDept2 = 0
      // job.userDefinedRoleOffice2 = 0
    }
    // 自定义岗位3
    if (userDefinedRoleId3List.length > 0) {
      job.userDefinedRoleId3 = userDefinedRoleId3 > 0 ? userDefinedRoleId3 : userDefinedRoleId3List[0].userId
      const user = await User.getUserById(job.userDefinedRoleId3)
      this.view.$nextTick(() => {
        this.userDefinedRoleId3Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId3 = 0
      // job.userDefinedRoleDept3 = 0
      // job.userDefinedRoleOffice3 = 0
    }
    // 自定义岗位4
    if (userDefinedRoleId4List.length > 0) {
      job.userDefinedRoleId4 = userDefinedRoleId4 > 0 ? userDefinedRoleId4 : userDefinedRoleId4List[0].userId
      const user = await User.getUserById(job.userDefinedRoleId4)
      this.view.$nextTick(() => {
        this.userDefinedRoleId4Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId4 = 0
      // job.userDefinedRoleDept4 = 0
      // job.userDefinedRoleOffice4 = 0
    }
    // 自定义岗位5
    if (userDefinedRoleId5List.length > 0) {
      job.userDefinedRoleId5 = userDefinedRoleId5 > 0 ? userDefinedRoleId5 : userDefinedRoleId5List[0].userId
      const user = await User.getUserById(job.userDefinedRoleId5)
      this.view.$nextTick(() => {
        this.userDefinedRoleId5Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId5 = 0
      // job.userDefinedRoleDept5 = 0
      // job.userDefinedRoleOffice5 = 0
    }
    // 自定义岗位6
    if (userDefinedRoleId6List.length > 0) {
      job.userDefinedRoleId6 = userDefinedRoleId6 > 0 ? userDefinedRoleId6 : userDefinedRoleId6List[0].userId
      const user = await User.getUserById(job.userDefinedRoleId6)
      this.view.$nextTick(() => {
        this.userDefinedRoleId6Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId6 = 0
      // job.userDefinedRoleDept6 = 0
      // job.userDefinedRoleOffice6 = 0
    }
    // 自定义岗位7
    if (userDefinedRoleId7List.length > 0) {
      job.userDefinedRoleId7 = userDefinedRoleId7 > 0 ? userDefinedRoleId7 : userDefinedRoleId7List[0].userId
      const user = await User.getUserById(job.userDefinedRoleId7)
      this.view.$nextTick(() => {
        this.userDefinedRoleId7Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId7 = 0
      // job.userDefinedRoleDept7 = 0
      // job.userDefinedRoleOffice7 = 0
    }
    this.getTxtSalesPrompt()
  }
  // 指定货 -> 加载网管
  async loadOverseaAgentDetailOwner(companyId) {
    this.ownerCompanyId = companyId
    const company = await Company.getCompanyById(companyId)
    if (company) {
      const overseaAgentDetail = await new Company(company).getOverseaAgentDetail()
      this.loadOverseaAgentDetailOwnerHandler(overseaAgentDetail)
    }
  }
  // 加载指定货代理详情
  async loadOverseaAgentDetailOwnerHandler(overseaAgentDetail) {
    const data = { value: 0 }
    if (overseaAgentDetail) {
      // 添加指定货代理等级
      const overseaAgentGrade = OverseaAgentGrade.getOverseaAgentGradeByCode(overseaAgentDetail.grade)
      if (overseaAgentGrade) {
        this.job.agentLevel = overseaAgentGrade.chineseName
      }
      const user = await User.getUserById(overseaAgentDetail.owner)
      if (user) {
        if (this.view.salesOfficeCheck) {
          if (user.active) {
            Object.assign(data, user)
            data.value = overseaAgentDetail.owner
          }
        } else {
          Object.assign(data, user)
          data.value = overseaAgentDetail.owner
        }
      }
    }
    this.salesChangeHandler(data)
  }
  // 销售修改事件
  async salesChangeHandler(data) {
    const job = this.job
    job.sales = data.value
    job.salesOffice = 0
    this.view.txtSalesOffice = ''
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === $store.getters.currentOfficeId)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          job.salesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          if (office) {
            job.salesOffice = office.officeId
          }
        }
      }
    }
    this.loadCompanyOffice()
    this.dispatchChangedSalesEvent(data.userId || 0)
  }
  // 手动选择销售
  dispatchChangedSalesEvent(sales) {
    // todo 待实现
    // var salesEvent: CommonFormEvent = new CommonFormEvent('salesChanged')
    // salesEvent.data = sales
    // view.dispatchEvent(salesEvent)
  }
  // 加载联系人信息
  async loadCustomerContacts() {
    const company = await Company.getCompanyById(this.job.customerId)
    this.view.contactList = []
    if (!company || !this.job.customerId) {
      return
    }
    this.view.contactList = await Company.loadContact(company.uuid)// 获取联系人
    if (this.view.contactList && this.view.contactList.length > 0) {
      if (!this.job.customerContact) {
        const contact = this.getDefaultContact(this.view.contactList)
        this.job.customerContact = contact ? contact.contactPerson : ''
        this.job.contactFax = contact ? contact.fax : ''
        this.job.contactTelephone = contact ? contact.telephone : ''
      }
    } else {
      this.job.customerContact = ''
      this.job.contactFax = ''
      this.job.contactTelephone = ''
    }
  }
  // 获取默认联系人
  getDefaultContact(ary) {
    let rs = null
    if (ary && ary.length > 0) {
      rs = ary[0]
      for (const contact of ary) {
        if (contact.defaultContact) {
          rs = contact
          break
        }
      }
    }
    return rs
  }
  sopChangeBookingAgentHandler() {
    if (this.view.editStatus) {
      return
    }
    const job = this.job
    if (!job.designationAgent) {
      this.view.$message.warning(this.view.$t('SeaExport.ChooseDesignatedAgent'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.designationAgent, 'DesignationAgent').then(data => {
      this.pageAResultHandler(data)
    })
  }
  sopChangeCustomerIdHandler() {
    if (this.view.editStatus) {
      return
    }
    const job = this.job
    if (!job.customerId) {
      this.view.$message.warning(this.view.$t('SeaExport.PleaseSelectTheEntrustingCompany'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.customerId, 'customer').then(data => {
      this.pageBResultHandler(data)
    })
  }
  pageAResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.designationAgent, 'DesignationAgent')
  }
  pageBResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.customerId, 'customer')
  }
  pageResultHandler(contactList, cmpIdx, agent) {
    this.view.sopDialog.cmpIdx = cmpIdx
    this.view.sopDialog.agent = agent
    this.view.sopDialog.contactList = contactList
    this.view.sopDialog.resultFunction = value => {
      this.saveSop(value, agent)
    }
    this.view.sopDialog.visible = true
  }
  saveSop(value, agent) {
    if (agent) {
      const job = this.job
      switch (agent) {
        case 'customer':
          job.ifPushSop = value
          break
        case 'DestinationAgent':
          job.ifPushSopM = value
          break
        case 'DesignationAgent':
          job.ifPushSopZ = value
          break
        case 'PortOfLoadingAgent':
          job.ifPushSopQ = value
          break
      }
    }
  }
  // 指定货代理
  async designationAgentChangeHandler(data) {
    const job = this.job
    job.designationAgent = data.value || 0
    this.view.sopImageA = false
    this.view.showWarningImageA = false
    if (this.view.creditOpen && data.value > 0) {
      this.checkCreditByCompany(data.value, 2)
    } else {
      const company = await Company.getCompanyById(job.designationAgent)
      if (this.view.sopConfigOpen && company) {
        // 判断该合作伙伴是否开启SOP
        this.view.sopImageA = company.ifOpenSop
      }
    }
    if (job.designationAgent > 0) {
      this.loadOverseaAgentDetail()
      this.checkNewJobCreditInfo()
      if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
        this.loadOverseaAgentUserByLob(job.designationAgent)// 根据指定货确定海外客服
      }
    } else {
      if (!this.view.isHC) {
        if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
          job.overseaOp = 0
          job.overseaOpDepartment = 0
          this.view.overseaAgentUsersList = []
        }
        await this.getOverseaAgentUserByConfig()
      }
    }
  }
  // 加载指定货代理
  async loadOverseaAgentDetail() {
    const job = this.job
    if (job.designationAgent > 0) {
      const company = await Company.getCompanyById(job.designationAgent)
      if (company) {
        this.loadOverSeaResultHandler()
      }
    }
  }
  // 指定货代理 销售处显示网管名字。
  loadOverSeaResultHandler(event = null) {
    if (this.job.designationAgent > 0) {
      this.loadOverseaAgentDetailOwner(this.job.designationAgent)
    }
  }
  // 销售悬浮提示
  getTxtSalesPrompt() {
    if (this.isSpecifiedSalesBusiness && (this.view.$refs.sales.options.length === 0)) {
      this.view.salesPrompt = this.view.$t('SeaExport.PleaseMaintainTheCorrespondingSalesInThePartner')
    } else {
      this.view.salesPrompt = ''
    }
  }
  // 销售部门修改后，调整分公司信息
  async departmentChargeHandler(data) {
    const job = this.job
    job.salesDepartment = data.value
    if (job.salesDepartment > 0) {
      const office = await Office.getOfficeByUuid(data.officeUuid)
      if (office && job.salesOffice !== office.officeId) {
        job.salesOffice = office.officeId
        this.loadCompanyOffice()
      }
    }
  }
  // 分公司调整
  async opOfficeChargeHandler(data) {
    const job = this.job
    job.opOffice = data.value
    if (!job.opOffice) {
      job.opDepartment = 0
    }
    JobUtils.opOfficeChange({ view: this.view, job, warehouseCallback: warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), modifiedData: this.context.modifiedData })
    this.view.contractRuleFieldChange(this.job.customerId, this.job.designationAgent)
  }
  // 客户修改
  async csrChangeHandler(data) {
    const job = this.job
    job.csr = data.value
    job.csrDepartment = 0
    job.csrOffice = 0
    if (data.value) {
      if (data.defaultDepId && data.defaultOfficeId && job.opOffice === data.defaultOfficeId) {
        job.csrOffice = data.defaultOfficeId
        job.csrDepartment = data.defaultDepId
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === $store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.csrOffice = office ? office.officeId : 0
              job.csrDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'csr')
          if (dep) {
            job.csrDepartment = dep.departmentId
            const office = await Office.getOfficeByUuid(dep.officeUuid)
            job.csrOffice = office ? office.officeId : 0
          }
        }
      }
    }
  }
  // 单证
  async dcChangeHandler(data) {
    const job = this.job
    job.dc = data.value
    job.dcDepartment = 0
    job.dcOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.dcOffice = office ? office.officeId : 0
            job.dcDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        job.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.dcOffice = office ? office.officeId : 0
      }
    } else {
      job.dc = 0
      job.dcDepartment = 0
      job.dcOffice = 0
    }
  }
  // 航线负责人
  async plannerChangeHandler(data) {
    const job = this.job
    job.planner = data.value
    job.plannerDepartment = 0
    job.plannerOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'airline', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.plannerOffice = office ? office.officeId : 0
            job.plannerDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'airline')
        job.plannerDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.plannerOffice = office ? office.officeId : 0
      }
    } else {
      job.planner = 0
      job.plannerDepartment = 0
      job.plannerOffice = 0
    }
  }
  // 现场操作
  async siteOpChangeHandler(data) {
    const job = this.job
    job.siteOP = data.value
    job.siteOpDepartment = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'siteOp', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            job.siteOpDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'siteOp')
        job.siteOpDepartment = dep ? dep.departmentId : 0
      }
    }
  }
  // 操作
  async opChangeHandler(data) {
    const job = this.job
    job.op = data.value
    job.opDepartment = 0
    if (data.value) {
      const user = new User(data)
      if (user.defaultDepId && user.defaultOfficeId && user.defaultOfficeId === job.opOffice) {
        job.opDepartment = user.defaultDepId
      } else {
        if (job.opOffice > 0) {
          user.getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          user.getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    }
  }
  // 海外客服
  async overseaOpChangeHandler(data) {
    if (!data) {
      data = User.getUserById(this.job.overseaOp)
    }
    const job = this.job
    job.overseaOpDepartment = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'overseaOp', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            job.overseaOpDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'overseaOp')
        job.overseaOpDepartment = dep ? dep.departmentId : 0
      }
    }
  }
  // 操作模式
  async operateTypeChangeHandler(data) {
    const job = this.job
    let request = false
    const oldOperateType = job.operateType
    job.operateType = data.value
    let lclMaster = job.lclMaster
    if (!lclMaster && job.lclMasterUuid) {
      // 加载主票
      lclMaster = await new AirExportJob(job).getLclMaster()
    }
    switch (oldOperateType) {
      case AirExportConstants.CONSOLE.code :
        if (lclMaster) {
          if (job.hasSharedCharge) {
            job.operateType = oldOperateType
            this.view.$message.warning('当前小票有分摊费用，不能切换操作模式！')
            return
          }
          if (lclMaster) {
            await new AirExportJob(lclMaster).getCharges()
            await new AirExportJob(lclMaster).getLclSlaves()
          }
          if (lclMaster.charges && lclMaster.charges.length > 0 && lclMaster.lclSlaves && lclMaster.lclSlaves.length === 1) {
            job.operateType = oldOperateType
            this.view.$message.warning(this.view.$t('queryJob.ThereMasterTicketThisPerformed'))
            return
          }
          if (lclMaster.lclSlaves && lclMaster.lclSlaves.length === 1) {
            request = true
            await this.consoleToOther(this.view.$t('queryJob.TheTicketIfYouSwitch'), data.value, oldOperateType)
          } else if (lclMaster.lclSlaves.length > 1) {
            request = true
            await this.consoleToOther(this.view.$t('queryJob.TheTheBindingRelationshipSwitch'), data.value, oldOperateType)
          }
        } else if (!job.uuid && job.mbl && job.mbl.length > 0) { this.view.taskType = 1 }
        break

      case AirExportConstants.DIRECT.code :
      case AirExportConstants.BACK_TO_BACK.code :
        if (job.operateType === 0 && job.mbl) {
          if (!job.uuid) {
            this.view.taskType = 2
          } else {
            request = true
            await this.toConsole(data.value, oldOperateType)
          }
        }
        break
      default :
        break
    }

    if (!request) {
      job.operateType = data.value
      job.mblOnly = job.operateType === parseInt(AirExportConstants.DIRECT.code)
      this.checkMAWBRelationState()
      await this.checkJobHBL()
    }
    if (!job.uuid) {
      LocalStorageUtils.setConfiguration('AEDefaultJobOperate', job.operateType)
    }
    // 根据操作模式自动获取对应的自定义业务类型，如果有多个默认选中第一个
    this.selectJobType()

    // CARGO-19844 ID：8353 辉恒 空运订舱直单的情况下希望能够取客户的收发通地址显示导MBL中
    if (job && job.uuid && (oldOperateType === parseInt(AirExportConstants.CONSOLE.code) || oldOperateType === parseInt(AirExportConstants.BACK_TO_BACK.code)) && job.operateType === parseInt(AirExportConstants.DIRECT.code)) {
      // 判断收发货人是否有内容
      const hasContent = CargoDocUtil.hasSFContent(job)
      if (hasContent) {
        this.view.$confirm(this.view.$t('Message.operateTypeUpdateTips'), {
          confirmButtonText: this.view.$t('common.tips.yes'),
          cancelButtonText: this.view.$t('common.tips.no'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(async() => {
          // 在基本页签点击保存，不切换MAWB页签时使用
          if (this.view.mawbDoc) {
            CargoDocUtil.copyBasicShipper(this.view.mawbDoc, job)
            CargoDocUtil.copyBasicConsignee(this.view.mawbDoc, job)
            CargoDocUtil.copyBasicNotify(this.view.mawbDoc, job)
          }
          // 切换MAWB页签时使用
          const mawbDoc = await new AirExportJob(job).getCargoDoc(CargoDocConsts.MAWB, false)
          if (mawbDoc) {
            CargoDocUtil.copyBasicShipper(mawbDoc, job)
            CargoDocUtil.copyBasicConsignee(mawbDoc, job)
            CargoDocUtil.copyBasicNotify(mawbDoc, job)
          }
        }).catch(() => {
        }).finally(() => {
        })
      }
    }
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    this.view.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.operateType, this.job.fba)
  }
  slacChangeHandler() {
    const job = this.job
    if (!job) return
    const slac = job.slac
    const mawbDoc = this.view.mawbDoc
    const hawbDoc = this.view.hawbDoc
    if (mawbDoc) {
      mawbDoc.slac = slac
    }
    if (hawbDoc) {
      hawbDoc.slac = slac
    }
  }

  /**
   * 修改计费重 ，同步计算英制计费重
   * @param oldKey
   * @param key
   * @returns {Promise<void>}
   */
  async chargeWeightImperialChange(oldKey, key) {
    if (this.job[oldKey]) {
      this.job[key] = await JobUtils.calculateWeight(this.job[oldKey], true)
    } else {
      this.job[key] = 0
    }

    if (oldKey === 'chargeWeightStation' && key === 'chargeWeightStationImperial') {
      await this.changeChargeWeightStation()
    }
  }
  async weightCubAgeImperialChangeHandler(type) {
    if (['weightBooking', 'cubageBooking'].includes(type)) {
      if (type === 'weightBooking') {
        this.job.weightBooking = await JobUtils.calculateWeight(this.job.weightBookingImperial)
      }
      if (type === 'cubageBooking') {
        this.job.cubageBooking = await JobUtils.calculateCubAge(this.job.cubAgeBookingImperial)
      }
      await this.weightCubageChangeHandler(type)
      this.job.chargeWeightBookingImperial = await JobUtils.calculateWeight(this.job.chargeWeightBooking, true)
    }
    if (['weightMBL', 'cubageMBL'].includes(type)) {
      if (type === 'weightMBL') {
        this.view.mawbDoc.weight = await JobUtils.calculateWeight(this.view.mawbDoc.weightImperial)
      }
      if (type === 'cubageMBL') {
        this.view.mawbDoc.cubage = await JobUtils.calculateCubAge(this.view.mawbDoc.cubAgeImperial)
      }
      await this.weightCubageChangeHandler(type)
      this.view.mawbDoc.chargeWeightImperial = await JobUtils.calculateWeight(this.view.mawbDoc.cWeight, true)
    }
  }
  async doWeightCubAgeChangeHandler(type) {
    if (['weightBooking', 'cubageBooking'].includes(type)) {
      if (type === 'weightBooking') {
        this.job.weightBookingImperial = await JobUtils.calculateWeight(this.job.weightBooking, true)
      }
      if (type === 'cubageBooking') {
        this.job.cubAgeBookingImperial = await JobUtils.calculateCubAge(this.job.cubageBooking, true)
      }
      await this.weightCubageChangeHandler(type)
      this.job.chargeWeightBookingImperial = await JobUtils.calculateWeight(this.job.chargeWeightBooking, true)
    }
    if (['weightMBL', 'cubageMBL'].includes(type)) {
      if (type === 'weightMBL') {
        this.view.mawbDoc.weightImperial = await JobUtils.calculateWeight(this.view.mawbDoc.weight, true)
      }
      if (type === 'cubageMBL') {
        this.view.mawbDoc.cubAgeImperial = await JobUtils.calculateCubAge(this.view.mawbDoc.cubage, true)
      }
      await this.weightCubageChangeHandler(type)
      this.view.mawbDoc.chargeWeightImperial = await JobUtils.calculateWeight(this.view.mawbDoc.cWeight, true)
    }
    if (type === 'chargeWeightMBL') {
      await this.weightCubageChangeHandler(type)
      this.view.mawbDoc.chargeWeightImperial = await JobUtils.calculateWeight(this.view.mawbDoc.cWeight, true)
    }
  }
  // 重量体积变更函数
  async weightCubageChangeHandler(type = '') {
    const job = this.job
    if (!job) return
    const mawbDoc = this.view.mawbDoc
    const hawbDoc = this.view.hawbDoc
    if (type === 'weightActual' || type === 'cubageActual') {
      const weight = isNaN(this.job.weightActual) ? 0 : this.job.weightActual
      const cubage = isNaN(this.job.cubageActual) ? 0 : this.job.cubageActual
      if (cubage) {
        this.job.densityActual = NumberUtils.ToFixed2(weight / cubage, 3)
      } else {
        this.job.densityActual = 0
      }
    }
    switch (type) {
      case 'quantityActual':
        this.changeSyncMAWBDocWeightCubage(type, job)
        if (!job.multipleDischargingPickups && job.dischargingTrucking && job.dischargingTrucking.length > 0) {
          job.dischargingTrucking[0].quantity = job.quantityActual || 0
          this.context.modifiedData.dischargingTruckingInfo = job.dischargingTrucking
        }
        break
      case 'quantityMBL':
        break
      case 'weightActual' :
      case 'cubageActual' :
      case 'pbProportion':
      case 'pbProportion2' : {
        const oldCWeight = lodash.cloneDeep(job.cWeight)
        job.cWeight = JobUtils.calcProportion(job.pbProportion, job.weightActual, job.cubageActual, true, this.cWeightIsCeil, this.view.splitBubbleCollectionFormat)
        if (oldCWeight !== job.cWeight) {
          await this.weightCubageChangeHandler('chargeWeightActual')
        }
        this.changeSyncMAWBDocWeightCubage(type, job)
        break
      }
      case 'weightMBL':
      case 'cubageMBL':
        if (mawbDoc) {
          mawbDoc.weight = isNaN(mawbDoc.weight) ? 0 : Number(Number(mawbDoc.weight).toFixed(3))
          mawbDoc.cubage = isNaN(mawbDoc.cubage) ? 0 : Number(Number(mawbDoc.cubage).toFixed(3))
          if (mawbDoc.cubage) {
            this.job.densityDoc = NumberUtils.ToFixed2(mawbDoc.weight / mawbDoc.cubage, 3)
          } else {
            this.job.densityDoc = 0
          }
          mawbDoc.cWeight = JobUtils.calcChargeWeight(mawbDoc.weight, mawbDoc.cubage, true, this.cWeightIsCeil)
        }
        break
      case 'chargeWeightMBL' :
        if (mawbDoc) {
          mawbDoc.cWeight = JobUtils.calcChargeWeight2(mawbDoc.cWeight, true, this.cWeightIsCeil)// 直接对计费重量判断计算
          mawbDoc.chargeWeightImperial = await JobUtils.calculateWeight(mawbDoc.cWeight, true)
        }
        break

      case 'chargeWeightActual': {
        job.cWeight = JobUtils.calcChargeWeight2(job.cWeight, true, this.cWeightIsCeil)
        if (!job.cWeight) {
          job.cWeight = 0
        }
        await this.chargeWeightImperialChange('cWeight', 'cWeightImperial')
        if (hawbDoc) {
          hawbDoc.cWeight = isNaN(job.cWeight) ? 0 : Number(job.cWeight.toFixed(3))
        }
        if (mawbDoc) {
          mawbDoc.cWeight = isNaN(job.cWeight) ? 0 : JobUtils.calcChargeWeight2(job.cWeight, true, this.cWeightIsCeil)
          mawbDoc.chargeWeightImperial = await JobUtils.calculateWeight(mawbDoc.cWeight, true)
        }
        let chargeFlag = false
        for (const charge of this.job.charges) {
          // 排除掉拆分费用
          if (!charge.confirmBillUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code) {
            chargeFlag = true
            break
          }
        }
        if (chargeFlag) {
          this.view.$confirm(this.view.$t('Message.TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated2'), {
            confirmButtonText: this.view.$t('common.btn.ok'),
            cancelButtonText: this.view.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            const charges = []
            for (const charge of this.job.charges) {
              if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
                !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && !charge.diffChargeUuid &&
                  !charge.verifiedAmount && !charge.paidOff && !charge.internalFrom) {
                charge.quantity = job.cWeight
                if (charge.unitPriceIncludeTax) {
                  ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
                } else {
                  ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
                }
                charges.push(charge)
              }
            }
            if (charges && charges.length > 0) {
              this.context.modifiedData.charges = this.context.modifiedData.charges || []
              mergeArray(this.context.modifiedData.charges, charges)
            }
          }).catch(() => {
          }).finally(() => {
          })
          await this.changeSynBillOfLadingQWC()
        }
        break
      }
      case 'chargeWeightContract':
        job.chargeWeight = isNaN(job.chargeWeight) ? 0 : job.chargeWeight
        break

      case 'weightContract':
      case 'cubageContract':
        job.chargeWeight = JobUtils.calcChargeWeight(job.weightContract, job.cubageContract, true, this.cWeightIsCeil)
        {
          const weight = isNaN(this.job.weightContract) ? 0 : this.job.weightContract
          const cubage = isNaN(this.job.cubageContract) ? 0 : this.job.cubageContract
          if (cubage) {
            this.job.densityContract = NumberUtils.ToFixed2(weight / cubage, 3)
          } else {
            this.job.densityContract = 0
          }
        }
        break
      case 'quantityStation':
        this.changeSyncMAWBDocWeightCubage(type, job)
        break
      case 'weightStation':
      case 'cubageStation':
        job.chargeWeightStation = JobUtils.calcChargeWeight(job.weightStation, job.cubageStation, true, this.cWeightIsCeil)
        {
          console.log('chargeWeightStation->', job.chargeWeightStation)
          const weight = isNaN(this.job.weightStation) ? 0 : this.job.weightStation
          const cubage = isNaN(this.job.cubageStation) ? 0 : this.job.cubageStation
          if (cubage) {
            this.job.densityStation = NumberUtils.ToFixed2(weight / cubage, 3)
          } else {
            this.job.densityStation = 0
          }
        }
        this.changeSyncMAWBDocWeightCubage(type, job)
        break
      case 'quantitySigning':
        this.changeSyncMAWBDocWeightCubage(type, job)
        break
      case 'weightSigning':
      case 'cubageSigning':
        job.chargeWeightSigning = JobUtils.calcChargeWeight(job.weightSigning, job.cubageSigning, true, this.cWeightIsCeil)
        {
          const weight = isNaN(this.job.weightSigning) ? 0 : this.job.weightSigning
          const cubage = isNaN(this.job.cubageSigning) ? 0 : this.job.cubageSigning
          if (cubage) {
            this.job.densitySigning = NumberUtils.ToFixed2(weight / cubage, 3)
          } else {
            this.job.densitySigning = 0
          }
        }
        this.changeSyncMAWBDocWeightCubage(type, job)
        break

      case 'chargeWeightBooking':
        break

      case 'quantityBooking':
        this.changeSyncMAWBDocWeightCubage(type, job)
        break
      case 'weightBooking':
      case 'cubageBooking':
        // job.chargeWeightBooking = JobUtils.calcChargeWeight(job.weightBooking, job.cubageBooking, false)
        job.chargeWeightBooking = JobUtils.calcChargeWeight(job.weightBooking, job.cubageBooking, true, this.cWeightIsCeil)
        {
          const weight = isNaN(this.job.weightBooking) ? 0 : this.job.weightBooking
          const cubage = isNaN(this.job.cubageBooking) ? 0 : this.job.cubageBooking
          if (cubage) {
            this.job.densityBooking = NumberUtils.ToFixed2(weight / cubage, 3)
          } else {
            this.job.densityBooking = 0
          }
        }
        this.changeSyncMAWBDocWeightCubage(type, job)
        break

      case 'measurements':
        if (mawbDoc) { mawbDoc.dimension = job.measurements }
        if (hawbDoc) { hawbDoc.dimension = job.measurements }
        if (job.dimensionsSigning) {
          this.job.docDimensions = job.dimensionsSigning
        } else if (job.freightStationDimensions) {
          this.job.docDimensions = job.freightStationDimensions
        } else if (job.dimensionsActual) {
          this.job.docDimensions = job.dimensionsActual
        } else {
          this.job.docDimensions = job.measurements
        }
        break
      case 'dimensionsSigning':
        this.job.docDimensions = job.dimensionsSigning
        break
      case 'freightStationDimensions':
        if (job.dimensionsSigning) {
          this.job.docDimensions = job.dimensionsSigning
        } else {
          this.job.docDimensions = job.freightStationDimensions
        }
        break
      case 'dimensionsActual':
        if (job.dimensionsSigning) {
          this.job.docDimensions = job.dimensionsSigning
        } else if (job.freightStationDimensions) {
          this.job.docDimensions = job.freightStationDimensions
        } else {
          this.job.docDimensions = job.dimensionsActual
        }
        break
      default :
        break
    }
    // 改变后去计算total的值并放入实体中。只有在主单的时候去修改它。
    if (mawbDoc) {
      await this.getTotal(mawbDoc)
    }
    if (hawbDoc) {
      if (hawbDoc.rateCharge === 'AS ARRANGED') {
        hawbDoc.cTotal = 'AS ARRANGED'
      } else {
        // CARGO-30906 ID：4976 恩跃 计费重量改变后，在HAWB页签重量*汇率显示的合计错误
        // const rateCharge = NumberUtils.parseNumber(hawbDoc.rateCharge)
        hawbDoc.cTotal = NumberUtils.formatNumber(hawbDoc.rateCharge * hawbDoc.cWeight, 2)
      }
      this.job.cWeightChange = true
      this.view.$emit('generalHChargeWeight')
    }
  }
  async changeChargeWeightStation(msg = '') {
    const job = this.job
    if (this.config.get('AESellPriceBuyPriceCreateFee') !== '1') {
      return
    }
    const selling = Number(job.selling)
    const buying = Number(job.buying)
    if (isNaN(selling) || isNaN(buying) || selling === 0 || buying === 0) {
      return
    }
    let chargeFlag = false
    for (const charge of this.job.charges) {
      // 排除掉拆分费用
      if (!charge.confirmBillUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code && (charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code || charge.measure === ChargeMeasure.SHIPMENT_CHARGE_MEASURE.code)) {
        chargeFlag = true
        break
      }
    }
    if (chargeFlag) {
      if (!msg || msg.length === 0) {
        msg = this.view.$t('Message.TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated2')
      }
      await this.view.$confirm(msg, {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const charges = []
        for (const charge of this.job.charges) {
          const chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
          if (!charge.confirmBillUuid && (charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code || charge.measure === ChargeMeasure.SHIPMENT_CHARGE_MEASURE.code) &&
              !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && !charge.diffChargeUuid &&
              !charge.verifiedAmount && !charge.paidOff && !charge.internalFrom) {
            if (chargeItem.scaleCode === 'A/F') {
              if (charge.receivable) {
                charge.unitRate = selling
                if (this.job.sellingCurrency && this.job.sellingCurrency.length > 0) {
                  charge.currency = this.job.sellingCurrency
                }
              } else {
                charge.unitRate = buying
                if (this.job.buyingCurrency && this.job.buyingCurrency.length > 0) {
                  charge.currency = this.job.buyingCurrency
                }
              }
            }
            // 有货站取货站，没有货站取前置仓，没有前置仓取订舱/委托
            charge.quantity = job.chargeWeightStation || job.cWeight || job.chargeWeightBooking || job.chargeWeightBooking || job.chargeWeight
            if (chargeItem.scaleCode === 'A/F') {
              if ((charge.receivable && this.job.sellPriceType === AirExportConstants.TOTAL_RRICE.code) || (!charge.receivable && this.job.buyPriceType === AirExportConstants.TOTAL_RRICE.code)) {
                charge.quantity = 1
                charge.measure = ChargeMeasure.SHIPMENT_CHARGE_MEASURE.code
                charge.amount = charge.unitRate
                await ChargeUtils.calculateExchangeRate(charge, job)
              } else if ((charge.receivable && this.job.sellPriceType === AirExportConstants.UNIT_PRICE.code) || (!charge.receivable && this.job.buyPriceType === AirExportConstants.UNIT_PRICE.code)) {
                charge.measure = chargeItem.measure
                charge.amount = NumberUtils.ToFixed2(charge.unitRate * charge.quantity, 2)
                await ChargeUtils.calculateExchangeRate(charge, job)
              }
            }
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
            charges.push(charge)
          }
        }
        if (charges && charges.length > 0) {
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
        }
      }).catch(() => {
      }).finally(() => {
      })
      await this.changeSynBillOfLadingQWC()
    }
  }
  changeSyncMAWBDocWeightCubage(type, job) {
    const mawbDoc = this.view.mawbDoc
    const hawbDoc = this.view.hawbDoc
    if (mawbDoc) {
      const actualQuantity = !job.quantityActual
      const stationQuantity = !job.quantityStation
      const signingQuantity = !job.quantitySigning
      const actual = !job.weightActual && !job.cubageActual
      const station = !job.weightStation && !job.cubageStation
      const signing = !job.weightSigning && !job.cubageSigning
      switch (type) {
        case 'quantityBooking':
          if (actualQuantity && stationQuantity && signingQuantity) {
            if (hawbDoc) {
              hawbDoc.quantity = job.quantityBooking
            }
            if (mawbDoc) {
              mawbDoc.quantity = job.quantityBooking
            }
          }
          break
        case 'weightBooking':
        case 'cubageBooking':
          if (actual && station && signing) {
            if (hawbDoc) {
              hawbDoc.weight = isNaN(job.weightBooking) ? 0 : Number(Number(job.weightBooking).toFixed(3))
              hawbDoc.cubage = isNaN(job.cubageBooking) ? 0 : Number(Number(job.cubageBooking).toFixed(3))
              hawbDoc.cWeight = job.chargeWeightBooking
            }
            if (mawbDoc) {
              mawbDoc.weight = isNaN(job.weightBooking) ? 0 : Number(Number(job.weightBooking).toFixed(3))
              mawbDoc.cubage = isNaN(job.cubageBooking) ? 0 : Number(Number(job.cubageBooking).toFixed(3))
              mawbDoc.cWeight = job.chargeWeightBooking
            }
            job.densityDoc = job.densityBooking
          }
          break
        case 'quantityActual':
          if (stationQuantity && signingQuantity) {
            if (job.quantityActual) {
              if (hawbDoc) {
                hawbDoc.quantity = job.quantityActual
              }
              if (mawbDoc) {
                mawbDoc.quantity = job.quantityActual
              }
            } else {
              this.changeSyncMAWBDocWeightCubage('quantityBooking', job)
            }
          }
          break
        case 'weightActual' :
        case 'cubageActual' :
        case 'pbProportion' :
        case 'pbProportion2' :
          if (station && signing) {
            if (job.weightActual || job.cubageActual) {
              if (hawbDoc) {
                hawbDoc.weight = isNaN(job.weightActual) ? 0 : Number(job.weightActual.toFixed(3))
                hawbDoc.cubage = isNaN(job.cubageActual) ? 0 : Number(job.cubageActual.toFixed(3))
                hawbDoc.cWeight = isNaN(job.cWeight) ? 0 : Number(job.cWeight.toFixed(3))
              }
              if (mawbDoc) {
                mawbDoc.weight = isNaN(job.weightActual) ? 0 : Number(job.weightActual.toFixed(3))
                mawbDoc.cubage = isNaN(job.cubageActual) ? 0 : Number(job.cubageActual.toFixed(3))
                mawbDoc.cWeight = JobUtils.calcProportion(job.pbProportion2, job.weightActual, job.cubageActual, true, this.cWeightIsCeil, this.view.splitBubbleCollectionFormat)
                if (mawbDoc.cubage) {
                  job.densityDoc = NumberUtils.ToFixed2(mawbDoc.weight / mawbDoc.cubage, 3)
                } else {
                  job.densityDoc = 0
                }
              }
            } else {
              this.changeSyncMAWBDocWeightCubage('weightBooking', job)
            }
          }
          break
        case 'quantityStation':
          if (signingQuantity) {
            if (job.quantityStation) {
              if (hawbDoc) {
                hawbDoc.quantity = job.quantityStation
              }
              if (mawbDoc) {
                mawbDoc.quantity = job.quantityStation
              }
            } else {
              if (job.quantityActual) {
                this.changeSyncMAWBDocWeightCubage('quantityActual', job)
              } else {
                this.changeSyncMAWBDocWeightCubage('quantityBooking', job)
              }
            }
          }
          break
        case 'weightStation':
        case 'cubageStation':
          if (signing) {
            if (job.weightStation || job.cubageStation) {
              if (hawbDoc) {
                hawbDoc.weight = isNaN(job.weightStation) ? 0 : Number(Number(job.weightStation).toFixed(3))
                hawbDoc.cubage = isNaN(job.cubageStation) ? 0 : Number(Number(job.cubageStation).toFixed(3))
                hawbDoc.cWeight = job.chargeWeightStation
              }
              if (mawbDoc) {
                mawbDoc.weight = isNaN(job.weightStation) ? 0 : Number(Number(job.weightStation).toFixed(3))
                mawbDoc.cubage = isNaN(job.cubageStation) ? 0 : Number(Number(job.cubageStation).toFixed(3))
                mawbDoc.cWeight = job.chargeWeightStation
              }
              job.densityDoc = job.densityStation
            } else {
              if (job.weightActual || job.cubageActual) {
                this.changeSyncMAWBDocWeightCubage('weightActual', job)
              } else {
                this.changeSyncMAWBDocWeightCubage('weightBooking', job)
              }
            }
          }
          break
        case 'quantitySigning':
          if (job.quantitySigning) {
            if (hawbDoc) {
              hawbDoc.quantity = job.quantitySigning
            }
            if (mawbDoc) {
              mawbDoc.quantity = job.quantitySigning
            }
          } else {
            if (job.quantityStation) {
              this.changeSyncMAWBDocWeightCubage('quantityStation', job)
            } else if (job.quantityActual) {
              this.changeSyncMAWBDocWeightCubage('quantityActual', job)
            } else {
              this.changeSyncMAWBDocWeightCubage('quantityBooking', job)
            }
          }
          break
        case 'weightSigning':
        case 'cubageSigning':
          if (job.weightSigning || job.cubageSigning) {
            if (hawbDoc) {
              hawbDoc.weight = isNaN(job.weightSigning) ? 0 : Number(Number(job.weightSigning).toFixed(3))
              hawbDoc.cubage = isNaN(job.cubageSigning) ? 0 : Number(Number(job.cubageSigning).toFixed(3))
              hawbDoc.cWeight = job.chargeWeightSigning
            }
            if (mawbDoc) {
              mawbDoc.weight = isNaN(job.weightSigning) ? 0 : Number(Number(job.weightSigning).toFixed(3))
              mawbDoc.cubage = isNaN(job.cubageSigning) ? 0 : Number(Number(job.cubageSigning).toFixed(3))
              mawbDoc.cWeight = job.chargeWeightSigning
            }
            job.densityDoc = job.densitySigning
          } else {
            if (job.weightStation || job.cubageStation) {
              this.changeSyncMAWBDocWeightCubage('weightStation', job)
            } else if (job.weightActual || job.cubageActual) {
              this.changeSyncMAWBDocWeightCubage('weightActual', job)
            } else {
              this.changeSyncMAWBDocWeightCubage('weightBooking', job)
            }
          }
          break
      }
    }
  }
  async changeSynBillOfLadingQWC() {
    this.view.context.reloadCharge = true
    await CargoDocUtil.changeSynBillOfLadingQWC(this.job, this.job.quantityActual, this.job.weightActual, this.job.cubageActual)
  }
  //
  async getTotal(mawbDoc) {
    this.view.iataPrice = await JobUtils.queryIataPriceCarrier(this.job, this.view.iataPrice)
    this.getRateAndTotal(this.view.iataPrice, mawbDoc)
  }
  //
  getRateAndTotal(iataPrice = null, cargoDoc = null) {
    if (cargoDoc) {
      if (iataPrice) {
        const level = new IataPrice(iataPrice).getPriceRange(cargoDoc.cWeight)
        cargoDoc.rateCharge = NumberUtils.formatNumber(level, 2)
        const t = level * cargoDoc.cWeight
        if (t < iataPrice.levelM) {
          cargoDoc.rateClass = 'M'
          cargoDoc.cTotal = cargoDoc.rateCharge = iataPrice.levelM
        } else {
          if (cargoDoc.cWeight >= 0 && cargoDoc.cWeight < 45) {
            cargoDoc.rateClass = 'N'
          } else if (cargoDoc.cWeight >= 45) {
            cargoDoc.rateClass = 'Q'
          }
          cargoDoc.cTotal = NumberUtils.formatNumber(level * cargoDoc.cWeight, 2)
        }
      }
    }
    this.view.$emit('generalMChargeWeight')
  }
  // 新增时加载默认值 空运订舱 新增时默认带入销售，控制销售默认值
  async checkSalesOfficeAndDepartment(job) {
    if (job.sales > 0) {
      const user = await User.getUserById(job.sales)
      if (user) {
        if (user.defaultDepId > 0) {
          job.salesDepartment = user.defaultDepId
        }
        if (user.defaultOfficeId > 0) {
          job.salesOffice = user.defaultOfficeId
        }
      }
    }
  }
  // 加载信控超期
  async loadIsWithinClosingAccountDate() {
    await ClosingAccount.isContainClosedCharge(this.context.office.officeId, this.job.jobNo).then(res => {
      this.isWithinCloseAccountDate = Boolean(res.data)
    })
  }
  //
  async selectJobType() {
    const job = this.job
    if (job) {
      await getSpecificBasicData(basicCacheKeys.basic_data_CutomJobType).then(data => {
        if (data && data.length > 0) {
          for (const p of data) {
            if (p.type === job.lob && p.containerLoadType === job.operateType) {
              job.customJobType = p.code
              break
            }
          }
        }
      })
    }
    if (job.operateType === 2) { // CARGO-7473 空出业务“直单”不应生成HAWB号
      job.hawb = null
    } else {
      this.view.hawbDoc = await new AirExportJob(job).getCargoDoc(CargoDocConsts.HAWB, true)
    }
  }
  async changeMAWBInfo(cmpIdx = 0) {
    const carrier = await Company.getCompanyById(cmpIdx > 0 ? cmpIdx : this.job.carrierId)
    if (!carrier) {
      this.job.planner = 0
    }
    let airline = null
    if (this.view.hawbDoc && this.view.hawbDoc.state < 2) {
      airline = this.view.hawbDoc.carrierBy = !carrier ? '' : carrier.shortName
    }
    if (this.view.mawbDoc && this.view.mawbDoc.state < 2) {
      airline = this.view.mawbDoc.carrierBy = !carrier ? '' : carrier.shortName
    }
    let refresh = true
    if (airline) {
      await queryMAWBInfo({ airline: airline, branchId: $store.getters.currentOfficeId }).then(async res => {
        const data = res.data
        if (!this.job.uuid) {
          // 新增业务时
          if (data && data.length > 0) {
            await this.changeMAWBInfoCommon(data) // 修改MAWB相关信息
            refresh = true
          }
        } else {
          this.view.mawbinfoDatas = data
          if (this.view.oldCarrierId > 0) {
            refresh = await this.queryOldMAWBInfo(this.view.oldCarrierId)
          } else {
            refresh = await this.changeMAWBInfoCommonTips(this.view.mawbinfoDatas)
          }
        }
      })
    }
    return refresh
  }
  // 查询老的航空公司对应的提单明细信息
  async queryOldMAWBInfo(oldCarrierId) {
    const oldCarrier = await Company.getCompanyById(oldCarrierId)
    let airline = null
    if (this.view.hawbDoc && this.view.hawbDoc.state < 2) {
      airline = !oldCarrier ? '' : oldCarrier.shortName
    }
    if (this.view.mawbDoc && this.view.mawbDoc.state < 2) {
      airline = !oldCarrier ? '' : oldCarrier.shortName
    }
    let refresh = true
    if (airline) {
      refresh = await queryMAWBInfo({ airline: airline, branchId: $store.getters.currentOfficeId }).then(async res => {
        if ((!this.view.mawbinfoDatas || this.view.mawbinfoDatas.length === 0) && (!res.data || res.data.length === 0)) {
          return false
        } else {
          return await this.changeMAWBInfoCommonTips(this.view.mawbinfoDatas)
        }
      })
    }
    return refresh
  }
  // 同步MAWB信息
  async changeMAWBInfoCommonTips(datas) {
    return await this.view.$confirm('是否刷新MAWB相关信息？', this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      type: 'warning'
    }).then(async() => {
      if (datas && datas.length > 0) {
        await this.changeMAWBInfoCommon(datas)
      } else {
        const mawbDoc = this.view.mawbDoc
        if (mawbDoc && mawbDoc.state < 2) {
          mawbDoc.accountCode = ''
          mawbDoc.accountingInfo = ''
          // mawbDoc.handingInfo = ''
          mawbDoc.IataCode = ''
          mawbDoc.notifyLine1 = ''
          mawbDoc.insuredAmount = ''
          mawbDoc.issuedBy = ''
          mawbDoc.otherCharge = null
        }
        const hawbDoc = this.view.hawbDoc
        if (hawbDoc && hawbDoc.state < 2) {
          hawbDoc.accountCode = ''
          hawbDoc.accountingInfo = ''
          // hawbDoc.handingInfo = ''
          hawbDoc.iataCode = ''
          hawbDoc.issuedBy = ''
        }
      }
      return true
    }).catch(() => {
      return false
    })
  }
  // 同步MAWB信息
  async changeMAWBInfoCommon(datas) {
    if (!datas || datas.length === 0) return
    const mawbDoc = this.view.mawbDoc
    const hawbDoc = this.view.hawbDoc
    const mawbInfo = datas[0]
    if (mawbInfo) {
      if (mawbDoc && mawbDoc.state < 2) {
        mawbDoc.accountCode = mawbInfo.accountNo
        mawbDoc.accountingInfo = mawbInfo.accountInfo
        // mawbDoc.handingInfo = mawbInfo.handingInfo
        mawbDoc.iataCode = mawbInfo.iataCode
        mawbDoc.notifyLine1 = mawbInfo.carrierAgentCity
        mawbDoc.insuredAmount = mawbInfo.insuredAmount
        mawbDoc.issuedBy = mawbInfo.issuedBy
        if (datas.length === 1) {
          await AirExportUtils.fillMAWBInfoOtherCharge(this.job, mawbDoc, mawbInfo.mawbInfoOtherCharge)
        }
      }
      if (hawbDoc && hawbDoc.state < 2) {
        hawbDoc.accountCode = mawbInfo.accountNo
        hawbDoc.accountingInfo = mawbInfo.accountInfo
        // hawbDoc.handingInfo = mawbInfo.handingInfo
        hawbDoc.iataCode = mawbInfo.iataCode
        hawbDoc.issuedBy = mawbInfo.issuedBy
      }
    }
  }
  // sop配置项目
  sopConfig() {
    this.view.sopImageA = false
    this.view.sopImageB = false
    this.view.sopImageC = false
    SopPushConfig.findByOfficeId(this.context.office.officeId).then(data => {
      this.configSuccessHandler(data.sopPushConfig)
    })
  }
  // sop配置回调函数
  async configSuccessHandler(sop) {
    if (sop) {
      this.view.sopConfigOpen = sop.ifAuto
      if (this.view.creditOpen) {
        this.checkCredit()
      } else if (this.view.sopConfigOpen) {
        const designationAgent = await Company.getCompanyById(this.job.designationAgent)
        this.view.sopImageA = designationAgent && designationAgent.ifOpenSop

        const customer = await Company.getCompanyById(this.job.customerId)
        this.view.sopImageB = customer && customer.ifOpenSop

        const destinationAgent = await Company.getCompanyById(this.job.destinationAgent)
        this.view.sopImageC = destinationAgent && destinationAgent.ifOpenSop
      }
    } else {
      this.checkCredit()
    }
  }
  // 检查业务提单
  async checkJobHBL() {
    const job = this.job
    if (!this.view.isEdit) { // 非编辑状态下，不创建只查询
      // 重新加载airCargoDoc
      job.airCargoDoc = ''
      this.view.hawbDoc = await new AirExportJob(job).getCargoDoc(CargoDocConsts.HAWB, false)
      this.view.mawbDoc = await new AirExportJob(job).getCargoDoc(CargoDocConsts.MAWB, false)
      if (!this.view.hawbDoc) {
        this.view.hawbDoc = new AirCargoDoc().fillDefaultValue().getData()
      }
      if (!this.view.mawbDoc) {
        this.view.mawbDoc = new AirCargoDoc().fillDefaultValue().getData()
      }
      return
    } else { // 编辑状态下， 如果没有提单信息，需要创建一个提单数据
      this.view.hawbDoc = await new AirExportJob(job).getCargoDoc(CargoDocConsts.HAWB, true)
      this.view.mawbDoc = await new AirExportJob(job).getCargoDoc(CargoDocConsts.MAWB, true)
      // 新增的时候，根据默认值带出对应的数据(需要考虑复制场景，复制的时候，如果勾选了HBL/MBL,则不根据默认值带出。)
      if (!job.uuid) {
        const copyMbl = Boolean(LocalStorageUtils.getConfiguration('COPY_MBL_' + job.lob))
        const copyHbl = Boolean(LocalStorageUtils.getConfiguration('COPY_HBL_' + job.lob))
        const entityDefValUtil = new EntityDefaultValueUtil($store.getters.currentOfficeId, this.view)
        if (!entityDefValUtil.defaultValues) {
          await entityDefValUtil.initEntityDefaultValue()
        }
        this.defaultCargoDoc = entityDefValUtil.cargoDoc
        if (this.defaultCargoDoc) {
          if (!this.view.isCopy || (this.view.isCopy && !copyMbl)) {
            for (let i = 1; i < 8; i++) {
              this.view.mawbDoc['notifyLine' + i] = this.defaultCargoDoc['aeMawbNotifyLine' + i]
            }
          }
          if (!this.view.isCopy || (this.view.isCopy && !copyHbl)) {
            for (let i = 1; i < 8; i++) {
              this.view.hawbDoc['notifyLine' + i] = this.defaultCargoDoc['aeHawbNotifyLine' + i]
            }
          }
        }
      }
      if (!this.view.hawbDoc.uuid) {
        this.view.hawbDoc.dvForCustoms = 'AS PER INV'
      }
      switch (job.operateType) {
        case parseInt(AirExportConstants.CONSOLE.code) :
          break
        case parseInt(AirExportConstants.BACK_TO_BACK.code) :
          if (!this.view.mawbDoc.uuid) {
            this.view.mawbDoc.dvForCustoms = 'NCV'
          }
          break
        case parseInt(AirExportConstants.DIRECT.code) :
          if (!this.view.mawbDoc.uuid) {
            this.view.mawbDoc.dvForCustoms = 'NCV'
          }
          break

        default:
          break
      }
      if (!job.airCargoDoc || job.airCargoDoc.length === 0) {
        job.airCargoDoc = []
      }
      let hasHawb = false
      let hasMawb = false
      for (const item of job.airCargoDoc) {
        if (!hasHawb && item.docType === CargoDocConsts.HAWB) {
          hasHawb = true
        }
        if (!hasMawb && item.docType === CargoDocConsts.MAWB) {
          hasMawb = true
        }
      }
      if (!hasHawb && !this.view.hawbDoc.uuid) {
        job.airCargoDoc.push(this.view.hawbDoc)
      }
      if (!hasMawb && !this.view.mawbDoc.uuid) {
        job.airCargoDoc.push(this.view.mawbDoc)
      }
    }
  }
  // 加载用户
  async loadUser() {
    if (this.isSpecifiedSalesBusiness) {
      const company = await Company.getCompanyById(this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadUserHandler(data)
        })
      } else {
        if (this.view.salesOfficeCheck) {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, $store.getters.currentOfficeId, true)
        } else {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, null, true)
        }
      }
    }
  }
  async loadUserHandler(companyUsers) {
    const salesList = []
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList = []
    if (this.view.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId, true)
    }
    if (companyUsers !== null && companyUsers.length > 0) {
      for (const u of companyUsers) {
        if (u.lob === this.job.lob || StrUtils.isEmpty(u.lob) || u.lob === 'ALL') {
          const user = await User.getUserById(u.userId)
          if (user != null && user.active && u.roleType === CargoOfRoleType.SALES_TYPE.code) {
            if (this.view.salesOfficeCheck) {
              for (const obj of officeSaleList) {
                if (user.userId === obj.userId) {
                  salesList.push(user)
                }
              }
            } else {
              salesList.push(user)
            }
          }
        }
      }
    }
    this.view.salesList = salesList
    this.getTxtSalesPrompt()
  }
  // 重置主分单关系
  checkMAWBRelationState() {
    const job = this.job
    this.view.propertiesEnabled.selectBtnEnabled = false
    this.view.propertiesEnabled.newConsoleBtnEnabled = false
    this.view.propertiesEnabled.attachBtnEnabled = false
    this.view.propertiesEnabled.deattachBtnEnabled = false
    if (!job || this.view.viewStatus) {
      this.view.propertiesEnabled.mblEnabled = false
      this.view.propertiesEnabled.bookingTermEnabled = false
      this.view.propertiesEnabled.expressEnabled = false
      return
    }
    this.view.propertiesEnabled.bookingTermEnabled = !job.mbl && !job.lclMasterUuid
    if (!job.express && (job.bookingTerm === BookingTerm.DB_BOOKING_TYPE.code || job.bookingTerm === BookingTerm.CB_BOOKING_TYPE.code)) {
      this.view.propertiesEnabled.selectBtnEnabled = false
      /**
       * CARGO-46018  单独小票在BookingTerm.DB_BOOKING_TYPE.code || job.bookingTerm === BookingTerm.CB_BOOKING_TYPE.code这两种模式下可以选择
       */
      if (this.view.editMawblNoMode === 1 && !job.lclMasterUuid) {
        this.view.propertiesEnabled.selectBtnEnabled = true
      }
      this.view.propertiesEnabled.newConsoleBtnEnabled = false
      this.view.propertiesEnabled.attachBtnEnabled = false
      this.view.propertiesEnabled.deattachBtnEnabled = !!job.lclMasterUuid
      this.view.propertiesEnabled.mblEnabled = true
      this.view.propertiesEnabled.expressEnabled = (job.operateType === AirExportConstants.DIRECT.code || job.operateType === AirExportConstants.CONSOLE.code) && !job.lclMasterUuid && (!job.mbl || job.mbl.length !== 11)
      return
    }
    if (!job.express) {
      const aEAllowInputMBL = Number(this.config.get('AEAllowInputMBL')) === 1
      this.view.propertiesEnabled.mblEnabled = aEAllowInputMBL && !job.lclMasterUuid
    } else {
      this.view.propertiesEnabled.mblEnabled = true
    }
    this.view.propertiesEnabled.expressEnabled = (job.operateType === AirExportConstants.DIRECT.code || job.operateType === AirExportConstants.CONSOLE.code) && !job.lclMasterUuid && (!job.mbl || job.mbl.length !== 11)
    switch (Number(job.operateType)) {
      case 0 :
        this.view.propertiesEnabled.selectBtnEnabled = false
        this.view.propertiesEnabled.newConsoleBtnEnabled = !job.mbl && !job.lclMasterUuid && !job.express
        this.view.propertiesEnabled.attachBtnEnabled = !job.mbl && !job.lclMasterUuid && !job.express
        if (!job.uuid) {
          this.view.propertiesEnabled.deattachBtnEnabled = false
        } else {
          this.view.propertiesEnabled.deattachBtnEnabled = (!!job.mbl || !!job.lclMasterUuid) && !job.express
        }
        break

      case 2 :
        this.view.propertiesEnabled.selectBtnEnabled = !job.mbl && !job.lclMasterUuid && !job.express
        this.view.propertiesEnabled.newConsoleBtnEnabled = false
        this.view.propertiesEnabled.attachBtnEnabled = false
        this.view.propertiesEnabled.deattachBtnEnabled = (!!job.mbl || !!job.lclMasterUuid) && !job.express
        break

      case 3 :
        this.view.propertiesEnabled.selectBtnEnabled = !job.mbl && !job.lclMasterUuid && !job.express
        this.view.propertiesEnabled.deattachBtnEnabled = (!!job.mbl || !!job.lclMasterUuid) && !job.express
        this.view.propertiesEnabled.newConsoleBtnEnabled = false
        this.view.propertiesEnabled.attachBtnEnabled = false
        break

      default :
        break
    }
    /**
     * CARGO-46018 不管操作模式 ,以友邦这家配置的参数为主
     * 配置EditMblNoMode
     * 0–自由编辑，可手动输入也可选择主单号列表
     * 1–友邦模式，当订舱性质=自订舱时，输入框置灰，只能通过选择列表主单号。否则可自由编辑，可手动也可列表选择
     */
    if (this.view.editMawblNoMode === 1 && !job.lclMasterUuid) {
      this.view.propertiesEnabled.selectBtnEnabled = true
    }
  }
  // 订舱代理选择
  async bookingAgentChangeHandler(data) {
    const job = this.job
    if (job.bookingAgent && parseInt(job.bookingAgent) > 0) {
      job.preBookingAgent = job.bookingAgent
    }
    if (!data.value) {
      job.bookingAgent = 0
      return
    }
    // 这个验证必须在 job.bookingAgent = event.value 赋值之前，否则此验证无意义
    SEUtils.refreshChargeAccountId(job, 'bookingAgent', this.view.$t('SeaExport.BookingAgent'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
    this.job.bookingAgent = data.value
    if (job.bookingAgent) {
      const bookingAgentCompany = await Company.getCompanyById(job.bookingAgent)
      if (bookingAgentCompany && bookingAgentCompany.airCmp) {
        job.carrierId = bookingAgentCompany.cmpIdx
      }
      this.view.context.reloadCharge = true
    }
  }
  // 订舱性质
  async bookingTermChangeHandler(data) {
    const job = this.job
    job.bookingTerm = data.value
    if (job.operateType === AirExportConstants.DIRECT.code) {
      await this.checkJobHBL()
    }
    this.checkMAWBRelationState()
  }
  // 起运港代理
  async localAgentChangeHandler(data) {
    this.job.localAgent = data.value
  }
  doMeasurementsChangeHandler(val) {
    this.job.measurements = val
    this.measurementsChangeHandler()
  }
  // 本地代理
  measurementsChangeHandler(data) {
    const job = this.job
    // const values = JobUtils.batchCalcCubageQuantity(job.measurements)
    // if (values && values.length === 2) {
    //   job.cubageContract = isNaN(values[0]) ? 0 : values[0]
    //   job.quantityContract = isNaN(values[1]) ? 0 : values[1]
    //   job.chargeWeight = JobUtils.calcChargeWeight(JobUtils.safeWeight(job.weightContract), job.cubageContract, true)
    // }
    if (this.view.hawbDoc) {
      this.view.hawbDoc.dimension = job.measurements
    }
    if (this.view.mawbDoc) {
      this.view.mawbDoc.dimension = job.measurements
    }
  }
  //
  async expressChangeHandler() {
    const job = this.job
    job.mbl = null
    this.checkMAWBRelationState()
  }
  // 主单运费条款
  paymentTermMBLChangeHandler(data) {
    this.job.paymentTermMBL = data.value
    if (this.view.mawbDoc) {
      this.changeFreightTerm(this.view.mawbDoc, this.job.paymentTermMBL)
    }
  }
  // 分单运输方式
  paymentTermHBLChangeHandler(data) {
    this.job.paymentTermHBL = data.value
    if (this.view.hawbDoc) {
      this.changeFreightTerm(this.view.hawbDoc, this.job.paymentTermHBL, true)
    }
  }
  // 主单分单运费条款改变，对应的币种等都要相应改动
  changeFreightTerm(awbDoc, keyValue, isChangeFreightTerm = false) {
    if (keyValue === 'CCBYPP') {
      awbDoc.currency = 'USD'
      awbDoc.wtVal = AirExportConstants.CC
      awbDoc.other = AirExportConstants.PP
    } else {
      awbDoc.wtVal = keyValue
      awbDoc.other = keyValue
      if (awbDoc && awbDoc.docType === CargoDocConsts.HAWB) {
        if (isChangeFreightTerm || (!isChangeFreightTerm && this.view.action !== 'copy' && !awbDoc.uuid)) {
          if (keyValue === AirExportConstants.CC) {
            awbDoc.currency = 'USD'
          } else if (keyValue === AirExportConstants.PP) {
            awbDoc.currency = 'CNY'
          }
        }
      }
      // 初次保存时才加个默认值，不然复制时修改的都被覆盖了
      if (!awbDoc.uuid && !awbDoc.currency) {
        if (keyValue === AirExportConstants.CC) {
          awbDoc.currency = 'USD'
        } else if (keyValue === AirExportConstants.PP) {
          if (CargoDocConsts.MAWB === awbDoc.docType) {
            awbDoc.currency = RateUtil.localCurrencyByOffice2()
            awbDoc.currency = awbDoc.currency === 'RMB' ? 'CNY' : awbDoc.currency
          } else {
            awbDoc.currency = 'CNY'
          }
        }
      }
    }
    // 修改数据
    this.refreshPPCC(awbDoc)
  }
  // 更新PP,CC值
  refreshPPCC(cargoDoc) {
    if (!cargoDoc) return
    this.changeWtvalPosition(cargoDoc, 'pp1', 'cc1', cargoDoc.wtVal)
    this.changeWtvalPosition(cargoDoc, 'pp2', 'cc2', cargoDoc.wtVal)
    this.changeWtvalPosition(cargoDoc, 'pp3', 'cc3', cargoDoc.wtVal)
    if (cargoDoc.docType === CargoDocConsts.HAWB) {
      if (!cargoDoc.pp4 && !cargoDoc.cc4 && !cargoDoc.pp5 && !cargoDoc.cc5) {
        cargoDoc.pp4 = 'AS ARRANGED'
      }
      if (!cargoDoc.pp4 && !cargoDoc.cc4) {
        cargoDoc.pp4 = cargoDoc.pp5
        cargoDoc.cc4 = cargoDoc.cc5
        cargoDoc.pp5 = ''
        cargoDoc.cc5 = ''
      }
      getSpecificBasicData(basicCacheKeys.basic_data_PaymentTerm).then(data => {
        if (data && data.length > 0) {
          for (const p of data) {
            if (this.job.paymentTermHBL && p.code === this.job.paymentTermHBL) {
              cargoDoc.accountingInfo = p.name
              break
            }
          }
        }
      })
    }
    this.changeWtvalPosition(cargoDoc, 'pp4', 'cc4', cargoDoc.other)
    this.changeWtvalPosition(cargoDoc, 'pp5', 'cc5', cargoDoc.other)
    this.refreshPPCC6(cargoDoc)
  }
  // 刷新PPCC6
  refreshPPCC6(cargoDoc) {
    const pp1 = !cargoDoc.pp1 ? 0 : NumberUtils.parseNumber(cargoDoc.pp1)
    const pp2 = !cargoDoc.pp2 ? 0 : NumberUtils.parseNumber(cargoDoc.pp2)
    const pp3 = !cargoDoc.pp3 ? 0 : NumberUtils.parseNumber(cargoDoc.pp3)
    const pp4 = !cargoDoc.pp4 ? 0 : NumberUtils.parseNumber(cargoDoc.pp4)
    const pp5 = !cargoDoc.pp5 ? 0 : NumberUtils.parseNumber(cargoDoc.pp5)
    if (!isNaN(pp1) && !isNaN(pp2) && !isNaN(pp3) && !isNaN(pp4) && !isNaN(pp5)) {
      const pp6 = pp1 + pp2 + pp3 + pp4 + pp5
      cargoDoc.pp6 = NumberUtils.formatNumber(pp6)
    } else if (isNaN(pp1)) {
      cargoDoc.pp6 = cargoDoc.pp1
    }

    const cc1 = !cargoDoc.cc1 ? 0 : NumberUtils.parseNumber(cargoDoc.cc1)
    const cc2 = !cargoDoc.cc2 ? 0 : NumberUtils.parseNumber(cargoDoc.cc2)
    const cc3 = !cargoDoc.cc3 ? 0 : NumberUtils.parseNumber(cargoDoc.cc3)
    const cc4 = !cargoDoc.cc4 ? 0 : NumberUtils.parseNumber(cargoDoc.cc4)
    const cc5 = !cargoDoc.cc5 ? 0 : NumberUtils.parseNumber(cargoDoc.cc5)
    if (!isNaN(cc1) && !isNaN(cc2) && !isNaN(cc3) && !isNaN(cc4) && !isNaN(cc5)) {
      const cc6 = cc1 + cc2 + cc3 + cc4 + cc5
      cargoDoc.cc6 = NumberUtils.formatNumber(cc6)
    } else if (isNaN(cc1)) {
      cargoDoc.cc6 = cargoDoc.cc1
    }
  }
  //
  changeWtvalPosition(cargoDoc, pp, cc, type) {
    const data = !cargoDoc[pp] ? cargoDoc[cc] : cargoDoc[pp]
    if (type === AirExportConstants.PP) {
      cargoDoc[pp] = data
      cargoDoc[cc] = ''
    } else if (type === AirExportConstants.CC) {
      cargoDoc[cc] = data
      cargoDoc[pp] = ''
    }
  }
  // 联系人改变
  contactChangeCloseHandler(data) {
    const job = this.job
    if (!job) return
    if (data) {
      job.customerContact = data.contactPerson
      job.contactTelephone = data.telephone
      job.contactFax = data.fax
    }
  }
  // 联系人改变
  async cargoSourceChangeHandler(data) {
    const job = this.job
    if (!job) return
    job.cargoSource = data.value
    if (CargoSource.NC_CARGO_SOURCE.code === job.cargoSource) {
      this.view.salesPrompt = ''
      this.view.txtSalesOffice = ''
      this.loadOverseaAgentDetailOwner(job.designationAgent)
    } else {
      this.view.salesPrompt = this.view.$t('SeaExport.RequiredItem')
      this.view.txtSalesOffice = this.view.$t('SeaExport.RequiredItem')
      job.designationAgent = 0
      const company = await Company.getCompanyById(job.customerId)
      if (company) {
        job.customerContact = null
        this.loadCustomerContacts()
        this.loadCustomerDetailNew()
        this.loadCompanyUser()
      } else {
        job.customerId = 0
        this.view.txtSalesOffice = ''
        job.sales = 0
        this.view.salesList = []
        if (this.view.salesOfficeCheck) {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, $store.getters.currentOfficeId, true)
        } else {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, null, true)
        }
      }
    }
    this.checkNewJobCreditInfo()
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) { // 如果是指定货
      await this.loadOverseaAgentUserByLob(job.designationAgent) // 根据指定货确定海外客服
    } else {
      await this.loadOverseaAgentUserByLob(job.destinationAgent)// 还是根据目的港代理确定海外客服
    }
    JobUtils.matchUserPortConfig(this.view, this.job)
  }

  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfo() {
    const job = this.job
    if (this.view.creditOpen && StrUtils.isEmpty(job.uuid)) {
      // 新增业务时，需要判断是否可以新增该业务 CARGO-9472 超信控的合作伙伴不能新增业务
      const params = JobUtils.getCreditCheckJob(job)
      await canCreateByCreditInfoDetail(params).then(async res => {
        if (res.data > 0) {
          const msg = {
            dangerouslyUseHTMLString: true,
            message: await JobUtils.checkDateAndAmountExceeded(res.data),
            type: 'warning',
            duration: 5000
          }
          this.view.$message.warning(msg)
          if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
            this.view.showWarningImageA = false
            job.designationAgent = 0
          } else {
            this.view.showWarningImageB = false
            job.customerId = 0
          }
        }
      })
    }
  }
  // 加载客户详情新版
  async loadCustomerDetailNew() {
    const job = this.job
    const customer = await Company.getCompanyById(job.customerId)
    if (!customer) return
    const customerDetail = await new Company(customer).getCustomerDetail()
    if (customerDetail) {
      if (this.isSpecifiedSalesBusiness) {
        if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code && job.designationAgent > 0) {
          this.loadOverseaAgentDetailOwner(job.designationAgent)
        }
        this.loadCompanyUser()
      } else if (!this.isSpecifiedSalesBusiness) {
        const user = await User.getUserById(customerDetail.sales)
        if (user && user.active) {
          if (this.view.salesOfficeCheck) {
            const userList = this.view.salesList
            job.sales = 0
            for (const item in userList) {
              if (user.userId === item.userId) {
                job.sales = customerDetail.sales
              }
            }
          } else {
            job.sales = customerDetail.sales
          }
          this.salesChangeHandler({ ...user, value: user.userId })
        }
      }
    }
  }
  // 把Job上的港口信息同步到CargoDoc上
  async syncJobPortCargoDoc(cargoDoc) {
    const job = this.job
    const airport = await AirPort.getAirportByCode(job.loadingPortCode)
    cargoDoc.signPlaceBL = this.getCity(airport)
    cargoDoc.airportOfDeparture = !airport ? '' : airport.englishName
    const airportDes = await AirPort.getAirportByCode(job.destinationPortCode)
    cargoDoc.airportOfDestination = !airportDes ? '' : airportDes.englishName
  }
  // 目的港代理选择
  async destinationAgentChangeHandler(data) {
    const job = this.job
    this.view.showWarningImageC = false
    job.destinationAgent = data.value
    if (this.view.creditOpen && data.value > 0) {
      this.checkCreditByCompany(data.value, 3)
    } else {
      if (data && this.view.sopConfigOpen) {
        this.view.sopImageC = data.ifOpenSop
      }
    }
    if (job.destinationAgent > 0) {
      this.loadOverseaAgentResultHandler()
      const company = await Company.getCompanyById(job.destinationAgent)
      if (company) {
        AirCargoDocUtil.checkAirOverseaAgentProperties(job)
        if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code && (this.refSelDesignationAgent || job.designationAgent === 0)) {
          job.designationAgent = company.designationAgent ? job.destinationAgent : job.designationAgent
          this.loadOverseaAgentDetail()
        }
        if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
          this.loadOverseaAgentUserByLob(job.destinationAgent).then(r => {})
        }
      }
    } else {
      if (!this.view.isHC) {
        if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
          job.overseaOp = 0
          job.overseaOpDepartment = 0
          this.view.overseaAgentUsersList = []
        }
        await this.getOverseaAgentUserByConfig()
      }
    }
    await this.syncDocHandlingInfo()
    JobUtils.matchUserPortConfig(this.view, job)
  }
  /**
   * 根据指定货 获取海外客服
   */
  async loadOverseaAgentUserByLob(cmpIdx) {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    const cmp = await Company.getCompanyById(cmpIdx)
    if (cmp) {
      const overseaAgentDetail = await new Company(cmp).getOverseaAgentDetail()
      this.loadDestinationAgentDetaiHandler(overseaAgentDetail)
    } else {
      this.view.overseaAgentUsersList = []
      await this.getOverseaAgentUserByConfig()
      // CARGO-32979 若对应代理不存在清空原海外客服，该字段不设置用户
      job.overseaOp = 0
      job.overseaOpDepartment = 0
      // const firstOption = this.view.overseaAgentUsersList[0]
      // job.overseaOp = firstOption ? firstOption.userId : 0
      // job.overseaOpDepartment = 0
      // if (firstOption) {
      //   const dep = await new User(firstOption).getDefaultDepartment('role', 'overseaOp')
      //   if (dep) {
      //     job.overseaOpDepartment = dep.departmentId
      //   }
      // }
    }
  }
  async loadDestinationAgentDetaiHandler(agent) {
    if (this.view.isHC) {
      return
    }
    if (!agent) {
      const job = this.job
      const cmpIdx = job.cargoSource === CargoSource.NC_CARGO_SOURCE.code ? job.designationAgent : job.destinationAgent
      const company = await Company.getCompanyById(cmpIdx)
      if (company) {
        agent = await new Company(company).getOverseaAgentDetail()
      }
    }
    if (agent) {
      const overseaAgentUserList = await new OverseaAgent(agent).getOverseaAgentUserList()
      await this.loadOverseaAgentUserHandler(overseaAgentUserList)
    } else {
      await this.getOverseaAgentUserByConfig()
    }
  }
  async loadOverseaAgentUserHandler(overseaAgentUsers) {
    if (this.view.isHC) {
      return
    }
    // 海外客服
    const overseaAgentUsersList = []
    let overseaAgentUserDefaultId = 0
    if (overseaAgentUsers && overseaAgentUsers.length > 0) {
      for (const u of overseaAgentUsers) {
        if (u.lob === this.job.lob || !u.lob || u.lob === 'ALL') {
          const user = await User.getUserById(u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaAgentUserDefaultId = u.userId
              }
              overseaAgentUsersList.push(user)
            }
          }
        }
      }
    }
    // 海外客服
    this.view.overseaAgentUsersList = overseaAgentUsersList
    // 海外客服默认值
    let overseaOp = 0
    if (overseaAgentUsersList.length > 0) {
      if (overseaAgentUserDefaultId > 0) {
        overseaOp = overseaAgentUserDefaultId
      } else {
        overseaOp = overseaAgentUsersList[0].userId
      }
      await this.setOverSeaOpHandler(overseaOp, overseaAgentUsersList)
    } else {
      this.job.overseaOp = 0
      this.job.overseaOpDepartment = 0
      await this.getOverseaAgentUserByConfig()
      // CARGO-32979 若对应代理不存在清空原海外客服，该字段不设置用户
      // if (this.view.overseaAgentUsersList && this.view.overseaAgentUsersList.length > 0) {
      //   overseaOp = this.view.overseaAgentUsersList[0].userId
      //   await this.setOverSeaOpHandler(overseaOp, this.view.overseaAgentUsersList)
      // }
    }
  }
  async setOverSeaOpHandler(overseaOp, overseaAgentUsersList) {
    let newUser = null
    if (overseaOp > 0) {
      newUser = await User.getUserById(overseaOp)
    }
    if (newUser && overseaOp !== this.job.overseaOp) {
      // 复制时判断
      if (this.view.isCopy) {
        const overseaUser = await User.getUserById(this.job.overseaOp)
        const oldOverseaUser = !overseaUser ? '' : !overseaUser.chineseName ? overseaUser.englishName : overseaUser.chineseName// 原业务 海外客服
        const newOverseaUser = !newUser ? '' : !newUser.chineseName ? newUser.englishName : newUser.chineseName// 新 海外客服
        if (overseaUser && this.isActiveOverSeaOp() && overseaAgentUsersList.find(p => p.userId === overseaUser.userId)) {
          overseaOp = this.job.overseaOp
        } else {
          let msg = this.view.$t('SeaExport.OverseaCustomerUpdate')
          msg = msg.replace('{0}', oldOverseaUser)
          msg = msg.replace('{1}', newOverseaUser)
          this.view.$confirm(msg, this.view.$t('Message.Prompt'), {
            confirmButtonText: this.view.$t('common.btn.ok'),
            cancelButtonText: this.view.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            this.job.overseaOp = overseaOp
          }).catch(() => {
            this.job.overseaOp = 0
          }).finally(() => {
            this.overseaOpChangeHandler()
          })
        }
      } else {
        this.job.overseaOp = overseaOp
        this.overseaOpChangeHandler()
      }
    }
  }
  async loadOverseaAgentResultHandler() {
    const job = this.job
    if (AirExportConstants.CONSOLE.code === job.operateType || AirExportConstants.BACK_TO_BACK.code === job.operateType) {
      const mawbDoc = this.view.mawbDoc
      if (mawbDoc && mawbDoc.state < 2) {
        const destCmp = await Company.getCompanyById(job.destinationAgent)
        mawbDoc.consigneeCode = ''
        mawbDoc.notifyCode = ''
        if (destCmp) {
          const overseaAgentDetail = await new Company(destCmp).getOverseaAgentDetail()
          if (overseaAgentDetail) {
            mawbDoc.consigneeLine1 = overseaAgentDetail.airAddressLine1
            mawbDoc.consigneeLine2 = overseaAgentDetail.airAddressLine2
            mawbDoc.consigneeLine3 = overseaAgentDetail.airAddressLine3
            mawbDoc.consigneeLine4 = overseaAgentDetail.airAddressLine4
            mawbDoc.consigneeLine5 = overseaAgentDetail.airAddressLine5
            mawbDoc.consigneeLine6 = overseaAgentDetail.airAddressLine6
            mawbDoc.consigneeLine7 = overseaAgentDetail.airAddressLine7
            if (overseaAgentDetail.airNotifyAddressLine1 ||
                overseaAgentDetail.airNotifyAddressLine2 ||
                overseaAgentDetail.airNotifyAddressLine3 ||
                overseaAgentDetail.airNotifyAddressLine4 ||
                overseaAgentDetail.airNotifyAddressLine5 ||
                overseaAgentDetail.airNotifyAddressLine6 ||
                overseaAgentDetail.airNotifyAddressLine7) {
              mawbDoc.notifyLine1 = overseaAgentDetail.airNotifyAddressLine1
              mawbDoc.notifyLine2 = overseaAgentDetail.airNotifyAddressLine2
              mawbDoc.notifyLine3 = overseaAgentDetail.airNotifyAddressLine3
              mawbDoc.notifyLine4 = overseaAgentDetail.airNotifyAddressLine4
              mawbDoc.notifyLine5 = overseaAgentDetail.airNotifyAddressLine5
              mawbDoc.notifyLine6 = overseaAgentDetail.airNotifyAddressLine6
              mawbDoc.notifyLine7 = overseaAgentDetail.airNotifyAddressLine7
            }
          }
        }
      }
    }
  }
  // 操作模式
  async consoleToOther(header = '', newOperateType, oldOperateType) {
    await this.$confirm(header, this.view.$t('Message.Confirm'), {
      confirmButtonText: this.view.$t('constant.yes'),
      cancelButtonText: this.view.$t('constant.no'),
      type: 'warning'
    }).then(async() => {
      await this.changeOperateType(newOperateType, oldOperateType)
    }).catch(() => {
      this.job.operateType = oldOperateType
    })
  }
  async toConsole(newOperateType, oldOperateType) {
    await this.$confirm(this.view.$t('queryJob.SwitchAMasterTicketSwitch'), this.view.$t('Message.Confirm'), {
      confirmButtonText: this.view.$t('constant.yes'),
      cancelButtonText: this.view.$t('constant.no'),
      type: 'warning'
    }).then(async() => {
      await this.changeOperateType(newOperateType, oldOperateType)
    }).catch(() => {
      this.job.operateType = oldOperateType
    })
  }
  async changeOperateType(newOperateType, oldOperateType) {
    this.job.operateType = newOperateType
    this.view.detchMasterJob = this.job.lclMaster
    this.view.loading = getLoading()
    let location = null
    if (!this.view.isFba) {
      location = LOG_AE_AIR_BOOKING.code
    }
    await changeOperateType({ job: this.job, newOperateType: newOperateType, currentOffice: $store.getters.currentOfficeId, location: location }).then(async res => {
      if (res.data) {
        this.job.version = res.data.version
        this.job.operateType = res.data.operateType
        this.job.mblOnly = res.data.mblOnly
        this.job.lclMasterUuid = res.data.lclMasterUuid
        this.job.lclMaster = res.data.lclMaster
        // 重新加载提单信息
        this.job.airCargoDoc = ''
        this.job.mbl = res.data.mbl
        this.job.atd = res.data.atd
      }
      await this.updateTree(oldOperateType)
    }).finally(() => {
      this.view.loading.close()
    })
  }
  async updateTree(oldOperateType) {
    this.view.$emit('changeOperateType', { job: this.job, masterJob: this.view.detchMasterJob, oldOperateType: oldOperateType })
    this.checkMAWBRelationState()
    await this.checkJobHBL()
    // view.dispatchEvent(new BookingEvent(BookingEvent.REFRESH_TABS));
  }
  // ETD变更
  async etdChange(value) {
    if (Number(this.config.get('syncSignDateBl')) === 0) {
      const cargoDocList = await new AirExportJob(this.job).getAirCargoDoc()
      for (const cargoDoc of cargoDocList) {
        const allow = (cargoDoc.docType === CargoDocConsts.MAWB || cargoDoc.docType === CargoDocConsts.HAWB ||
            cargoDoc.docType === CargoDocConsts.HAWB2) && cargoDoc.state < 2 && (!cargoDoc.signDateBL ||
            (value && dateCompare(DateUtils.formatStandardDate(cargoDoc.signDateBL), DateUtils.formatStandardDate(value)) === 0))
        if (allow) {
          cargoDoc.signDateBL = this.job.etd
        }
      }
    }
    await ChargeUtils.updateETDFee(this.job, this.job.etd, this.context, true)
    if (this.job.etd) {
      JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    }
  }
  // 发货人选择
  async shipperAutoCompleteChange(data) {
    const job = this.job
    job.shipperId = data.value
    if (!job.shipperId) return
    const company = new Company(data)
    await company.getMainfestAddress()
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.job.shipperCode = company.englishName
      this.job.shipperLine1 = manifestaddress.addressLine1
      this.job.shipperLine2 = manifestaddress.addressLine2
      this.job.shipperLine3 = manifestaddress.addressLine3
      this.job.shipperLine4 = manifestaddress.addressLine4
      this.job.shipperLine5 = manifestaddress.addressLine5
      this.job.shipperLine6 = manifestaddress.addressLine6
    } else {
      this.job.shipperCode = ''
      this.job.shipperLine1 = ''
      this.job.shipperLine2 = ''
      this.job.shipperLine3 = ''
      this.job.shipperLine4 = ''
      this.job.shipperLine5 = ''
      this.job.shipperLine6 = ''
    }
  }
  // 收货人选择
  async consigneeAutoCompleteChange(data) {
    const job = this.job
    job.consigneeId = data.value
    if (!job.consigneeId) return
    const company = new Company(data)
    await company.getMainfestAddress()
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.job.consigneeCode = company.englishName
      this.job.consigneeLine1 = manifestaddress.addressLine1
      this.job.consigneeLine1 = manifestaddress.addressLine2
      this.job.consigneeLine1 = manifestaddress.addressLine3
      this.job.consigneeLine1 = manifestaddress.addressLine4
      this.job.consigneeLine1 = manifestaddress.addressLine5
      this.job.consigneeLine1 = manifestaddress.addressLine6
    } else {
      this.job.consigneeCode = ''
      this.job.consigneeLine1 = ''
      this.job.consigneeLine2 = ''
      this.job.consigneeLine3 = ''
      this.job.consigneeLine4 = ''
      this.job.consigneeLine5 = ''
      this.job.consigneeLine6 = ''
    }
  }
  // 通知人选择
  async notifyAutoCompleteChange(data) {
    const job = this.job
    job.notifyId = data.value
    if (!job.notifyId) return
    const company = new Company(data)
    await company.getMainfestAddress()
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.job.notifyCode = company.englishName
      this.job.notifyLine1 = manifestaddress.addressLine1
      this.job.notifyLine2 = manifestaddress.addressLine2
      this.job.notifyLine3 = manifestaddress.addressLine3
      this.job.notifyLine4 = manifestaddress.addressLine4
      this.job.notifyLine5 = manifestaddress.addressLine5
      this.job.notifyLine6 = manifestaddress.addressLine6
    } else {
      this.job.notifyCode = ''
      this.job.notifyLine1 = ''
      this.job.notifyLine2 = ''
      this.job.notifyLine3 = ''
      this.job.notifyLine4 = ''
      this.job.notifyLine5 = ''
      this.job.notifyLine6 = ''
    }
  }
  // 装货港选择
  async loadingPortCodeChange(data) {
    const job = this.job
    this.view.loadingPortChanged = false
    if (job.usCustomsClearance && job.loadingPortCode && data && data.value && data.value !== job.loadingPortCode) {
      this.view.loadingPortChanged = true
      job.loadingPortCode = data.value || ''
      if (!job.usCustomsClearanceList || job.usCustomsClearanceList.length === 0) {
        await new AirExportJob(job).getUsCustomsClearanceList()
      }
      JobUtils.updateUsCustomsClearanceList(job)
    } else {
      if (data) {
        job.loadingPortCode = data.value || ''
      } else {
        job.loadingPortCode = ''
      }
    }
    this.updateLoading3Code()
    const mawb = await new AirExportJob(job).getCargoDoc(CargoDocConsts.MAWB, false)
    if (mawb) { this.syncJobPortCargoDoc(mawb) }
    const hawb = await new AirExportJob(job).getCargoDoc(CargoDocConsts.HAWB, false)
    if (hawb) { this.syncJobPortCargoDoc(hawb) }
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
  }
  //
  async updateLoading3Code() {
    this.view.loading3Code = ''
    if (this.job.loadingPortCode) {
      const port = await AirPort.getAirportByCode(this.job.loadingPortCode)
      if (port) {
        this.view.loading3Code = port.code
      }
    }
  }
  // 目的港选择
  async destinationPortCodeChange(data) {
    const job = this.job
    if (data) {
      job.dischargingPortCode = data.value
      job.destinationPortCode = data.value
    } else {
      job.dischargingPortCode = ''
      job.destinationPortCode = ''
    }
    const mawbDoc = this.view.mawbDoc
    const hawbDoc = this.view.hawbDoc
    if (hawbDoc && hawbDoc.state < 2) { hawbDoc.podTo = job.destinationPortCode }
    if (mawbDoc && mawbDoc.state < 2) { mawbDoc.podTo = job.destinationPortCode }
    this.updateDestination3Code()
    this.checkVesselLine()
    const destinationPort = await AirPort.getAirportByCode(job.destinationPortCode)
    if (!job.destinationPlace) {
      job.destinationPlace = destinationPort ? destinationPort.englishName : ''
    }
    const mawb = await new AirExportJob(job).getCargoDoc(CargoDocConsts.MAWB, false)
    if (mawb) { await this.syncJobPortCargoDoc(mawb) }
    const hawb = await new AirExportJob(job).getCargoDoc(CargoDocConsts.HAWB, false)
    if (hawb) { this.syncJobPortCargoDoc(hawb) }
    await this.loadWarehouseRegion(true)
    await JobUtils.matchUserPortConfig(this.view, job)
    await JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
  }
  //
  async updateDestination3Code() {
    this.view.destination3Code = ''
    if (this.job.destinationPortCode) {
      const port = await AirPort.getAirportByCode(this.job.destinationPortCode)
      if (port) {
        this.view.destination3Code = port.code
      }
    }
  }
  // 显示目的港航线
  async checkVesselLine() {
    const job = this.job
    this.view.vesselLine = ''
    if (job.destinationPortCode) {
      const port = await AirPort.getAirportByCode(job.destinationPortCode)
      if (port) {
        const regions = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
        const region = regions.find(p => p.code === port.region)
        this.view.vesselLine = region ? (this.view.isZh ? region.name : region.nameEnglish) : ''
      }
    }
  }
  // 发货人选择
  async shipperChange(data) {
    const form = this.job
    form.shipperId = data.value
    if (form.shipperId) {
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.shipperLine1 = manifestAddress.addressLine1
        form.shipperLine2 = manifestAddress.addressLine2
        form.shipperLine3 = manifestAddress.addressLine3
        form.shipperLine4 = manifestAddress.addressLine4
        form.shipperLine5 = manifestAddress.addressLine5
        form.shipperLine6 = manifestAddress.addressLine6
        form.shipperLine7 = manifestAddress.addressLine7
      } else {
        form.shipperLine1 = ''
        form.shipperLine2 = ''
        form.shipperLine3 = ''
        form.shipperLine4 = ''
        form.shipperLine5 = ''
        form.shipperLine6 = ''
        form.shipperLine7 = ''
      }
    }
    const syncCustomerShippingInfoBothBolAndBasicTab = parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 0 || parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1 ||
        (parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 2 && this.view.action === 'add')
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.syncDocSft(true, false, false)
    }
  }
  async shipperCodeChange(data) {
    if (this.syncCustomerShippingInfoBothBolAndBasicTab) {
      this.syncDocSft(true, false, false)
    }
  }
  // 收货人选择
  async consigneeChange(data) {
    const form = this.job
    form.consigneeId = data.value
    if (form.consigneeId) {
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.consigneeLine1 = manifestAddress.addressLine1
        form.consigneeLine2 = manifestAddress.addressLine2
        form.consigneeLine3 = manifestAddress.addressLine3
        form.consigneeLine4 = manifestAddress.addressLine4
        form.consigneeLine5 = manifestAddress.addressLine5
        form.consigneeLine6 = manifestAddress.addressLine6
        form.consigneeLine7 = manifestAddress.addressLine7
      } else {
        form.consigneeLine1 = ''
        form.consigneeLine2 = ''
        form.consigneeLine3 = ''
        form.consigneeLine4 = ''
        form.consigneeLine5 = ''
        form.consigneeLine6 = ''
        form.consigneeLine7 = ''
      }
    }
    const syncCustomerShippingInfoBothBolAndBasicTab = parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 0 || parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1 ||
        (parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 2 && this.view.action === 'add')
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.syncDocSft(false, true, false)
    }
    JobUtils.matchUserPortConfig(this.view, this.job)
  }
  async consigneeCodeChange(data) {
    if (this.syncCustomerShippingInfoBothBolAndBasicTab) {
      this.syncDocSft(false, true, false)
    }
  }
  // 通知人选择
  async notifyChange(data) {
    const form = this.job
    form.notifyId = data.value
    if (form.notifyId) {
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.notifyLine1 = manifestAddress.addressLine1
        form.notifyLine2 = manifestAddress.addressLine2
        form.notifyLine3 = manifestAddress.addressLine3
        form.notifyLine4 = manifestAddress.addressLine4
        form.notifyLine5 = manifestAddress.addressLine5
        form.notifyLine6 = manifestAddress.addressLine6
        form.notifyLine7 = manifestAddress.addressLine7
      } else {
        form.notifyLine1 = ''
        form.notifyLine2 = ''
        form.notifyLine3 = ''
        form.notifyLine4 = ''
        form.notifyLine5 = ''
        form.notifyLine6 = ''
        form.notifyLine7 = ''
      }
    }
    const syncCustomerShippingInfoBothBolAndBasicTab = parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 0 || parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1 ||
        (parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 2 && this.view.action === 'add')
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.syncDocSft(false, false, true)
    }
  }
  async notifyCodeChange(data) {
    if (this.syncCustomerShippingInfoBothBolAndBasicTab) {
      this.syncDocSft(false, false, true)
    }
  }
  async fillModel(submitData = false) {
    const job = this.job
    if (!job || this.view.viewStatus) return
    await this.initCargoDocInformationOfNewJob(submitData)
    // 英文品名
    const newCargoEnglishName = job.cargoEnglishName ? job.cargoEnglishName.trim() : ''
    const oldCargoEnglishName = this.view.oldCargoEnglishName ? this.view.oldCargoEnglishName.trim() : ''
    if (this.view.cargoEnglishNameChange || (newCargoEnglishName && newCargoEnglishName !== oldCargoEnglishName)) {
      AirCargoDocUtil.syncCargoEnglishName(job, this.view.hawbDoc, this.airCargoEnglishName, 0)
      AirCargoDocUtil.syncCargoEnglishName(job, this.view.mawbDoc, this.airCargoEnglishName, 0)
      this.view.cargoEnglishNameChange = false
      this.view.oldCargoEnglishName = job.cargoEnglishName
    }
    // 唛头
    if (this.view.markChange || (job.mark && job.mark !== this.view.oldMark)) {
      AirCargoDocUtil.syncMark(job, this.view.hawbDoc, this.airCargoMark, 0)
      AirCargoDocUtil.syncMark(job, this.view.mawbDoc, this.airCargoMark, 0)
      this.view.markChange = false
      this.view.oldMark = job.mark
    }
  }
  async firstTimeCargoDoc(cargoDoc) {
    const job = this.job
    const copyMbl = Boolean(LocalStorageUtils.getConfiguration('COPY_MBL_' + job.lob))
    const copyHbl = Boolean(LocalStorageUtils.getConfiguration('COPY_HBL_' + job.lob))
    if (!cargoDoc.uuid) { // 新增情况下
      if (this.view.isCopy) { // 复制
        if ((!copyMbl && cargoDoc.docType === CargoDocConsts.MAWB) || (!copyHbl && cargoDoc.docType === CargoDocConsts.HAWB)) { // 没有勾选HAWB或者MAWB
          if (this.airCargoMark > 0) { // 配置同步
            if (!cargoDoc.remark1) {
              cargoDoc.remark1 = job.mark
            }
          } else {
            if (!cargoDoc.remark1) {
              cargoDoc.remark1 = job.mark
            }
          }
          if (this.airCargoEnglishName > 0) { // 配置同步
            if (!cargoDoc.cargoEnglishName) {
              cargoDoc.cargoEnglishName = job.cargoEnglishName
            }
          } else {
            if (!cargoDoc.cargoEnglishName) {
              cargoDoc.cargoEnglishName = job.cargoEnglishName
            }
          }
        }
      } else { // 非复制
        if (this.airCargoMark > 0) { // 配置同步
          if (!cargoDoc.remark1) {
            cargoDoc.remark1 = job.mark
          }
        } else {
          if (!cargoDoc.remark1) {
            cargoDoc.remark1 = job.mark
          }
        }
        if (this.airCargoEnglishName > 0) { // 配置同步
          if (!cargoDoc.cargoEnglishName) {
            cargoDoc.cargoEnglishName = job.cargoEnglishName
          }
        } else {
          if (!cargoDoc.cargoEnglishName) {
            cargoDoc.cargoEnglishName = job.cargoEnglishName
          }
        }
      }
    }
    // HAWB都刷，只有直单情况下才刷MAWB.
    if ((cargoDoc.docType === CargoDocConsts.HAWB || job.operateType === AirExportConstants.DIRECT.code && cargoDoc.docType === CargoDocConsts.MAWB) &&
        cargoDoc.remark1 && cargoDoc.remark1.trim().length === 0) {
      cargoDoc.remark1 = Number(this.config.get('refCargoDocRemark')) === 1 ? job.mark : ''
    }
    if (cargoDoc.docType === CargoDocConsts.HAWB &&
        (job.operateType === AirExportConstants.CONSOLE.code || job.operateType === AirExportConstants.BACK_TO_BACK.code) && !cargoDoc.accountingInfo) {
      cargoDoc.accountingInfo = ''
      const paymentTerms = await getCacheListByKey(basicCacheKeys.basic_data_PaymentTerm)
      for (const item of paymentTerms) {
        if (job.paymentTermHBL && item.code === job.paymentTermHBL) {
          cargoDoc.accountingInfo = item.name
          break
        }
      }
    }
    if (!cargoDoc.uuid) {
      await this.syncJobPortCargoDoc(cargoDoc)
    }
  }
  // 交货地改变
  destinationPlaceChange(str) {
    this.job.destinationPlace = StrUtils.toUpperCase(str)
  }
  // 航空公司
  async airlineCompanyChangeHandler(value) {
    // 记录老的航空公司Id
    this.view.oldCarrierId = this.job.carrierId
    // 新航空公司Id
    this.job.carrierId = value
    const syncHandingInfo = await this.changeMAWBInfo(0)
    if (syncHandingInfo) {
      await this.syncDocHandlingInfo()
    }
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
  }

  /**
   * 改变航空公司带出逻辑
   * @param value
   */
  airlineCompanyChange(value) {
    if (this.view.$refs.mawbNoInput && value && !this.job.express && Number(this.config.get('AEAllowInputMBL')) === 1) {
      let flg = false
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', value)
      if (company) {
        const airline = getObjectByCache(basicCacheKeys.basic_data_Airline, 'companyUuid', company.uuid)
        if (airline && airline.mawbprefix) {
          this.job.mbl = airline.mawbprefix + this.view.$refs.mawbNoInput.mawbNo
          flg = true
        }
      }
      this.view.$refs.mawbNoInput.splitMbl(this.job.mbl, flg)
    }
  }
  /**
   * 投保
   */
  async toInsure() {
    const payload = {
      jobUuid: this.job.uuid,
      branchId: this.view.$store.getters.currentOfficeId,
      billno: this.job.mbl,
      insureType: 'JOB'
    }
    const continueExec = await JobUtils.openInsure(payload, this.view)
    if (continueExec) {
      // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
      this.view.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
        params: { insureForm: payload }
      })
    }
    // if (Number(this.config.get('isPlatformInsurance')) === 3) {
    //   const payload = {
    //     jobUuid: this.job.uuid,
    //     branchId: $store.getters.currentOfficeId,
    //     billno: this.job.mbl,
    //     insureType: 'JOB'
    //   }
    //   const continueExec = await JobUtils.openInsure(payload, this.view)
    //   if (continueExec) {
    //     // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
    //     this.view.$router.push({
    //       name: 'ToInsurePage',
    //       query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
    //       params: { insureForm: payload }
    //     })
    //   }
    //   return
    // }
    // if (this.config.get('BurialPointMode') === 'on') {
    //   // LogStores.sendFunctionClickLogStoresByLabel('AE-基本' + this.view.$t('SeaExport.Insure'))
    // }
    // if (this.view.$checkPermission(['button_insurance_toInsure'])) {
    //   let mawb = null
    //   for (const doc of this.job.airCargoDoc) {
    //     if (doc.docType === 'MAWB') {
    //       mawb = doc
    //       break
    //     }
    //   }
    //   const job = deepCopy(this.job)
    //   cleanCircleObject(job)
    //   AirExportJob.toInsure(mawb, job, this.context.office).then(data => {
    //     this.insureSuccessHandler(data)
    //   })
    // } else {
    //   this.view.$message.warning(this.view.$t('SeaExport.NotInsuranceOperationPermission'))
    // }
  }
  /**
   * 投保成功
   */
  // insureSuccessHandler(data) {
  //   const result = data.result
  //   const status = data.status
  //   if (status === 'true') {
  //     window.open(result, '_blank', 'noreferrer')
  //   } else {
  //     this.view.$message.warning(result)
  //   }
  // }
  async loadWarehouseRegion(updateWarehousing = false) {
    const job = this.job
    if (parseInt(this.config.get('AssociatedRoute')) !== 1 || !job.destinationPortCode) return
    const port = await AirPort.getAirportByCode(job.destinationPortCode)
    if (port) {
      const regions = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
      let region = null
      if (regions && regions.length > 0) {
        region = regions.find(p => p.code === port.region)
      }
      if (region && region.warehouseRegions && region.warehouseRegions.length > 0) {
        let companyList = await getSpecificBasicData(basicCacheKeys.basic_data_Company)
        if (companyList && companyList.length > 0) {
          companyList = companyList.filter(item => item.warehouse && item.active) || []
        }
        if (region.warehouseRegions.length === 1) {
          const warehouse = companyList.find(p => p.uuid === region.warehouseRegions[0].companyUuid)
          if (warehouse) {
            if (updateWarehousing && job.uuid) {
              await this.warehouseCmpChangeHandler({ value: warehouse.cmpIdx })
            }
          }
        } else {
          if (updateWarehousing) {
            let defaultWarehouseCompany = null
            const warehouseCompanyList = []
            for (const warehouseRegion of region.warehouseRegions) {
              const warehouseCompany = companyList.find(p => p.uuid === warehouseRegion.companyUuid)
              if (warehouseCompany) {
                if (warehouseCompanyList.findIndex(p => p.uuid === warehouseCompany.uuid) < 0) {
                  warehouseCompanyList.push(warehouseCompany)
                }
              }
            }
            if (warehouseCompanyList && warehouseCompanyList.length > 0) {
              for (const warehouseCompany of warehouseCompanyList) {
                await new Company(warehouseCompany).getWarehouseDetail()
                const defaultWarehouse = Company.defaultWarehouse(warehouseCompany)
                if (defaultWarehouse) {
                  defaultWarehouseCompany = warehouseCompany
                  break
                }
              }
              if (!job.warehouseCmp || job.warehouseCmp === 0) {
                if (defaultWarehouseCompany) {
                  await this.warehouseCmpChangeHandler({ value: defaultWarehouseCompany.cmpIdx })
                } else {
                  await this.warehouseCmpChangeHandler({ value: 0 })
                }
              }
            }
          }
        }
      }
    }
  }
  async warehouseCmpChangeHandler(data) {
    const job = this.job
    job.warehouseCmp = data.value || 0
    job.warehouseRecord = job.warehouseCmp
    if (job.warehouseInfo.length === 0) {
      const newData = new WarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.warehouseInfo.push(newData)
    }
    // 通过此方法加载 warehouseInfo 的联系电话地址等
    await this.getWarehouseInfo()
    const warehouse = job.warehouseInfo[0]
    warehouse.warehouseCmp = job.warehouseCmp
    if (warehouse.warehouseCmp && warehouse.warehouseCmp > 0) warehouse.deleted = false
    this.addWarehouseToModifiedSet(warehouse)
  }
  // 添加warehouseInfo到被修改的集合中
  addWarehouseToModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
    if (!modifiedData.warehouseInfo.includes(warehouse)) {
      modifiedData.warehouseInfo.push(warehouse)
    }
  }
  // 自定义岗位字段1
  async userDefinedRoleId1Handler(data) {
    const job = this.job
    job.userDefinedRoleId1 = data.value || 0
    job.userDefinedRoleDept1 = 0
    job.userDefinedRoleOffice1 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice1 = office ? office.officeId : 0
            job.userDefinedRoleDept1 = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
        job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice1 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段2
  async userDefinedRoleId2Handler(data) {
    const job = this.job
    job.userDefinedRoleId2 = data.value || 0
    job.userDefinedRoleDept2 = 0
    job.userDefinedRoleOffice2 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice2 = office ? office.officeId : 0
            job.userDefinedRoleDept2 = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
        job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice2 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段3
  async userDefinedRoleId3Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId3 = value || 0
    job.userDefinedRoleDept3 = 0
    job.userDefinedRoleOffice3 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept3 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice3 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
        job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice3 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段4
  async userDefinedRoleId4Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId4 = value || 0
    job.userDefinedRoleDept4 = 0
    job.userDefinedRoleOffice4 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept4 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice4 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
        job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice4 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段5
  async userDefinedRoleId5Handler(data) {
    const job = this.job
    job.userDefinedRoleId5 = data.value || 0
    job.userDefinedRoleDept5 = 0
    job.userDefinedRoleOffice5 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept5 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice5 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
        job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice5 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段6
  async userDefinedRoleId6Handler(data) {
    const job = this.job
    job.userDefinedRoleId6 = data.value || 0
    job.userDefinedRoleDept6 = 0
    job.userDefinedRoleOffice6 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept6 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice6 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
        job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice6 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段7
  async userDefinedRoleId7Handler(data) {
    const job = this.job
    job.userDefinedRoleId7 = data.value || 0
    job.userDefinedRoleDept7 = 0
    job.userDefinedRoleOffice7 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept7 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice7 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
        job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice7 = office ? office.officeId : 0
      }
    }
  }
  // 获取实际入库日期和实际出库日期
  async getWarehouseDate() {
    let warehouseInList = []
    if (!this.job.warehouseIn || this.job.warehouseIn.length <= 0) {
      warehouseInList = await new AirExportJob(this.job).getWarehouseIn()
    }
    if (warehouseInList.length > 0) {
      const warehouseInListOrders = warehouseInList.filter(p => p.warehouseInDate)
      const curWarehouseIns = sortByMultiField(warehouseInListOrders, ['warehouseInDate'], true) // 降序
      if (curWarehouseIns && curWarehouseIns.length > 0) {
        this.job.warehouseInDate = curWarehouseIns[0].warehouseInDate
        this.job.warehouseOutDate = curWarehouseIns[0].warehouseOutDate
      }
    }
  }

  // 更改目的港代理或者航空公司或者操作要求需要同步 形式分单
  async syncDocHandlingInfo() {
    const handlingInfoConfig = this.config.get('HandlingInfoConfig')
    const handlingInfoConfigArr = handlingInfoConfig ? handlingInfoConfig.split(',') : ''

    // 合作伙伴航空公司维护的信息
    let handingInfoOne = ''
    if (this.job.carrierId && this.job.carrierId > 0 && handlingInfoConfig.indexOf('1') !== -1) {
      const carrier = await Company.getCompanyById(this.job.carrierId)
      let airline = null
      if (this.view.hawbDoc && this.view.hawbDoc.state < 2) {
        airline = this.view.hawbDoc.carrierBy = !carrier ? '' : carrier.shortName
      }
      if (this.view.mawbDoc && this.view.mawbDoc.state < 2) {
        airline = this.view.mawbDoc.carrierBy = !carrier ? '' : carrier.shortName
      }
      if (airline) {
        const info = await queryMAWBInfo({ airline: airline, branchId: $store.getters.currentOfficeId }).then(async res => {
          return (res.data && res.data.length > 0) ? res.data[0] : null
        })
        handingInfoOne = info ? info.handingInfo : ''
      }
    }
    let handingInfoTwo
    if (handlingInfoConfig.indexOf('2') !== -1) {
      // 目的港代理地址
      handingInfoTwo = await AirCargoDocUtil.handingInfoTwoFunc(this.job.destinationAgent, handlingInfoConfig)
    }
    // 操作要求
    let handingInfoThree = ''
    if (handlingInfoConfig.indexOf('3') !== -1) {
      if (this.job.operationContent && handlingInfoConfig.indexOf('3') !== -1) {
        const operationContentArr = await OperationRequirementDescription.getListByLob(this.job.lob)
        const valueSet = new Set(this.job.operationContent.split('\n'))
        for (const item of operationContentArr) {
          // 排除非 handlingInfo的
          if (item.operationRequirementType !== Number(SystemConstants.TYPE_HANDLING_INFO.code)) {
            continue
          }
          if (valueSet.has(item.contentDescription)) {
            if (handingInfoThree) handingInfoThree += '\n'
            handingInfoThree += item.contentDescription
          }
        }
      }
    }
    // 将值组装成map
    const map = new Map()
    if (handingInfoOne) map.set('1', handingInfoOne)
    if (handingInfoTwo) map.set('2', handingInfoTwo)
    if (handingInfoThree) map.set('3', handingInfoThree)
    // 同步逻辑
    let mawbStr = ''
    let hawbStr = ''

    // HandlingInfoConfig=1时，航司信息同步到MAWB和HAWB
    if (handlingInfoConfig.indexOf('1') !== -1 && handingInfoOne) {
      mawbStr = handingInfoOne
      hawbStr = handingInfoOne
    }

    // HandlingInfoConfig=2或3时，目的港代理地址和操作要求只同步到HAWB
    for (const config of handlingInfoConfigArr) {
      // 跳过航司信息的处理（已在上面处理过）
      if (config === '1') continue

      const curValue = map.get(config)
      if (curValue) {
        if (hawbStr) hawbStr += '\n'
        hawbStr += curValue
      }
    }

    // 更新MAWB和HAWB
    if (this.view.mawbDoc) {
      this.view.mawbDoc.handingInfo = mawbStr
    }
    if (this.view.hawbDoc) {
      this.view.hawbDoc.handingInfo = hawbStr
    }
  }

  /**
   * CARGO-30747 空运出口，在基本页面收发通输入内容后，可以同步到HAWB页面
   * 同步提单收发通
   * 业务模式【直单】时：基本页签收发通 同步到 MAWB页签收发通
   * 业务模式非直单时：基本页签收发通同步到HAWB页签收发通
   * @returns {Promise<void>}
   */
  async syncDocSft(shipper = false, consignee = false, notify = false) {
    const job = this.job
    // 订舱预审，则不同步
    if (job.jobState === -1 || this.view.action === 'look') {
      return
    }
    if (job.operateType === parseInt(AirExportConstants.DIRECT.code)) {
      // 业务模式【直单】时：基本页签收发通 同步到 MAWB页签收发通
      const mawb = await new AirExportJob(this.job).getCargoDoc(CargoDocConsts.MAWB, false)
      if (mawb) {
        if (shipper) new AirCargoDoc(mawb).copyBasicShipper(job, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
        if (consignee) new AirCargoDoc(mawb).copyBasicConsignee(job, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
        if (notify) new AirCargoDoc(mawb).copyBasicNotify(job, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
        this.view.$emit('syncDocSft', mawb, shipper, consignee, notify)
      }
    } else {
      // 业务模式非直单时：基本页签收发通同步到HAWB页签收发通
      const hawb = await new AirExportJob(this.job).getCargoDoc(CargoDocConsts.HAWB, false)
      if (hawb) {
        if (shipper) new AirCargoDoc(hawb).copyBasicShipper(job, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
        if (consignee) new AirCargoDoc(hawb).copyBasicConsignee(job, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
        if (notify) new AirCargoDoc(hawb).copyBasicNotify(job, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
        this.view.$emit('syncDocSft', hawb, shipper, consignee, notify)
      }
    }
  }

  getDimensionData(map, dimension) {
    if (!dimension) {
      return
    }
    const arr = dimension.split('*')
    if (!arr || arr.length !== 4) {
      return // 长*宽*高*件数，非这个格式则不处理
    }
    const key = arr[0] + '*' + arr[1] + '*' + arr[2]
    const quantity = Number(map.get(key) || 0) + Number(arr[3])
    map.set(key, quantity)
  }
  /**
   * 获取货物信息
   * CARGO-34109 空运出口-货物信息页签中尺寸，同步到MAWB中的Dimension栏
   */
  getCargoInformation() {
    if (!this.job.uuid) return
    warehouseInList(this.job.uuid).then(res => {
      const result = res.data
      if (result && result.length > 0) {
        const map = new Map()
        for (const item of result) {
          const dimension = item.dimension
          if (!dimension) continue // 判断尺寸是否为空
          if (item.frontEndWarehouse === '1') {
            const list = item.dimension.split(';')
            for (const d of list) {
              this.getDimensionData(map, d)
            }
          } else {
            this.getDimensionData(map, dimension)
          }
        }
        if (map) {
          const sizeArr = []
          map.forEach(function(value, key) {
            sizeArr.push((key + '*' + value))
          })
          const size = sizeArr.join('\n')
          if (size) {
            this.job.measurements = size
            this.measurementsChangeHandler()
          }
        }
      }
    })
  }

  async cargoSalesChargeHandler(data) {
    const job = this.job
    job.cargoSalesId = data.value || 0
    job.cargoSalesDepartment = 0
    job.cargoSalesOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.cargoSalesOffice = office ? office.officeId : 0
            job.cargoSalesDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'salesOfGoods')
        if (department) {
          job.cargoSalesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          job.cargoSalesOffice = office ? office.officeId : 0
        }
      }
    }
  }
  async initCargoDocInformationOfNewJob(submitData = false) {
    const job = this.job
    if (!job.uuid) {
      // 操作模式为直单 或者 一主一分时，才会有mawb。才会执行以下方法。
      if (job.operateType === AirExportConstants.DIRECT.code || job.operateType === AirExportConstants.BACK_TO_BACK.code) {
        const mawbDoc = this.view.mawbDoc
        if (!mawbDoc.uuid) {
          await AirCargoDocUtil.checkAirOverseaAgentProperties(job)
        }
        if (!mawbDoc.wtVal || !mawbDoc.uuid) {
          this.changeFreightTerm(mawbDoc, job.paymentTermMBL, false)
        }
        await this.firstTimeCargoDoc(mawbDoc)
        if (!mawbDoc.uuid) {
          mawbDoc.notifyLine1 = 'SAME AS CONSIGNEE'
          if (!mawbDoc.signByCarrier || !mawbDoc.signByCarrier) {
            mawbDoc.signByCarrier = this.config.get('MAWBSignByCarrierDefaultValue')
          }
        }
      }
      const hawbDoc = this.view.hawbDoc
      if (!hawbDoc.wtVal || !hawbDoc.uuid) {
        this.changeFreightTerm(hawbDoc, job.paymentTermHBL, false)
      }
      await this.firstTimeCargoDoc(hawbDoc)
      // CARGO-16548 空运出口复制订单时，基本界面收发通没有自动带入到提单件界面
      const hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + job.lob)
      if (!job.uuid && (this.view.action !== 'copy' || (this.view.isCopy && !hbl && !submitData))) { // 业务新增时，将收发通同步到HAWB
        hawbDoc.shipperId = job.shipperId
        hawbDoc.shipperCode = job.shipperCode
        hawbDoc.shipperLine1 = job.shipperLine1
        hawbDoc.shipperLine2 = job.shipperLine2
        hawbDoc.shipperLine3 = job.shipperLine3
        hawbDoc.shipperLine4 = job.shipperLine4
        hawbDoc.shipperLine5 = job.shipperLine5
        hawbDoc.shipperLine6 = job.shipperLine6
        hawbDoc.consigneeId = job.consigneeId
        hawbDoc.consigneeCode = job.consigneeCode
        hawbDoc.consigneeLine1 = job.consigneeLine1
        hawbDoc.consigneeLine2 = job.consigneeLine2
        hawbDoc.consigneeLine3 = job.consigneeLine3
        hawbDoc.consigneeLine4 = job.consigneeLine4
        hawbDoc.consigneeLine5 = job.consigneeLine5
        hawbDoc.consigneeLine6 = job.consigneeLine6
        hawbDoc.notifyId = job.notifyId
        hawbDoc.notifyCode = job.notifyCode
        hawbDoc.notifyLine1 = job.notifyLine1
        hawbDoc.notifyLine2 = job.notifyLine2
        hawbDoc.notifyLine3 = job.notifyLine3
        hawbDoc.notifyLine4 = job.notifyLine4
        hawbDoc.notifyLine5 = job.notifyLine5
        hawbDoc.notifyLine6 = job.notifyLine6
      }
    }
  }
  // 唛头修改事件
  async markChangeHandler(value) {
    const job = this.job
    if (!job || this.view.viewStatus) return
    this.view.oldMark = job.mark
    job.mark = value
    await this.markBlurHandler()
  }
  async markBlurHandler() {
    const job = this.job
    if (!job || this.view.viewStatus || this.view.showMarkOrCargoEnglishNameDialog) return
    if (job.mark && this.airCargoMark && [1, 2].includes(this.airCargoMark)) {
      const oldMark = this.view.oldMark
      if (oldMark !== job.mark) {
        this.view.markChange = true
        AirCargoDocUtil.syncMark(job, this.view.mawbDoc, this.airCargoMark, 0)
        AirCargoDocUtil.syncMark(job, this.view.hawbDoc, this.airCargoMark, 0)
      }
    }
  }
  // 英文品名修改事件
  async cargoEnglishNameChangeHandler(value) {
    const job = this.job
    if (!job || this.view.viewStatus) return
    this.view.oldCargoEnglishName = this.job.cargoEnglishName
    this.view.showMarkOrCargoEnglishNameDialog = false
    job.cargoEnglishName = value
    await this.cargoEnglishNameBlurHandler()
  }
  async cargoEnglishNameBlurHandler() {
    const job = this.job
    if (!job || this.view.viewStatus || this.view.showMarkOrCargoEnglishNameDialog) return
    if (job.cargoEnglishName && this.airCargoEnglishName && [1, 2].includes(this.airCargoEnglishName)) {
      const oldCargoEnglishName = this.view.oldCargoEnglishName
      if (oldCargoEnglishName !== job.cargoEnglishName) {
        this.view.cargoEnglishNameChange = true
        AirCargoDocUtil.syncCargoEnglishName(job, this.view.mawbDoc, this.airCargoEnglishName, 0)
        AirCargoDocUtil.syncCargoEnglishName(job, this.view.hawbDoc, this.airCargoEnglishName, 0)
      }
    }
  }
}
